// CacheKey 56e7b87ef4178254d992debd94894838
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    helpers: {
      submit: {
        question: {
          create: "Create Question",
          update: "Update Question"
        }
      }
    },
    simple_form: {
      yes: "Yes",
      no: "No",
      required: {
        text: "required",
        mark: "*"
      },
      error_notification: {
        default_message: "Please review the problems below:"
      },
      options: {
        conditional_format: {
          operator: {
            equals: "Equals",
            not_equal: "Not Equal",
            contains: "Contains"
          }
        }
      },
      labels: {
        defaults: {
          _type: "Type",
          after_sign_in_url: "After Sign-In URL",
          care_form_requirement: "Require Care Form",
          care_provider: "Care Provider",
          care_provider_id: "Care Provider",
          caregiver: "Caregiver",
          case_manager: "Case Manager",
          csv: "CSV File",
          data_view_ids: "Data Views",
          date_of_birth: "Date of Birth",
          date_of_death: "Date of Death",
          due_date: "Due Date",
          employer_id: "Employer ID",
          end_date: "End Date",
          enable_shared_insights_content: "Enable Shared Content",
          first_name: "First Name",
          free_text_question: "Free Text Question",
          home_healthprima: "Caregiver Name",
          import_association_name: "Association Name",
          ios_version: "iOS Version",
          issue_alert: "Issue Alert",
          issue_alert_id: "Issue Alert",
          issue_alert_ids: "Issue Alerts",
          issue_panel: "Issue Panel",
          issue_panel_id: "Issue Panel",
          issue_panel_ids: "Issue Panels",
          key_metric_requirement: "Require Metric",
          default_generated_audio_script: "Generated Audio Script",
          default_language: "Language",
          generated_audio_script: "Generated Audio Script",
          language: "Language",
          language_ids: "Languages",
          last_name: "Last Name",
          launch_status: "Launch Restriction",
          lower_bound: "Lower Limit",
          manual_edits_only: "Manual Edits Only",
          middle_name: "Middle Name",
          mrn: "MRN",
          notify_care_team: "Notify Care Team",
          outreach_action: "Outreach Action",
          outreach_action_id: "Outreach Action",
          outreach_eligible: "Outreach Eligible?",
          outreach_program: "Outreach Program",
          outreach_program_id: "Outreach Program",
          outreach_program_ids_to_check: "Outreach Programs To Check",
          patient_tag_ids: "Patient Tags",
          insights_dashboard_ids: "Insights Dashboards",
          place_of_service: "Place of Service",
          point_of_origin: "Point of Origin",
          post_discharge_limit: "Post Discharge Limit",
          previously_closed_by_employee_id: "Previously Closed by Employee ID",
          previously_closed_by_employer_id: "Previously Closed by Employer ID",
          primary_physician: "Primary Physician",
          program_requirement: "Require Program",
          provider_role_ids: "Provider Roles",
          quick_task: "As Needed Task",
          reporting_name: "Reporting Name",
          require_note_before_completion: "On Completion",
          require_note_before_dismissal: "On Dismissal",
          require_notes: "Require Notes",
          require_patient_tag_before_completion: "On Completion",
          require_patient_tags: "Require Patient Tags",
          roundable: "Roundable?",
          rounding_flag: "Rounding Flag",
          rounding_flag_ids: "Rounding Flags",
          rounding_script: "Rounding Script",
          rounding_script_id: "Rounding Script",
          rounding_script_ids: "Rounding Scripts",
          selected_facilities: "Selected Facilities",
          short_name: "Short Name",
          skill_set: "Skill-Set",
          sort_order: "Sort Order",
          staff_member: "Staff Member",
          staff_rounding_flag_id: "Staff Rounding Flag",
          start_date: "Start Date",
          survey_location_id: "Survey Location",
          survey_location_ids: "Survey Locations",
          task_restrictions: "Restrict",
          team_member: "Assigned To",
          time_needed: "Time Needed",
          unit_id: "Unit",
          upper_bound: "Upper Limit",
          escalation_history: {
            name: "Escalated to"
          }
        },
        atlas_enrollment: {
          patient_id: "Patient",
          workflow_ids: "Workflows",
          phone: "Phone",
          last_updated_at: "Last Updated At"
        },
        factor_program: {
          default: "Default Patient Prioritization Settings"
        },
        atlas_faq: {
          topic_id: "Topic"
        },
        atlas_service_request_configuration: {
          name: "Name",
          group: "Group",
          issue_alert_id: "Issue Alert",
          issue_panel_id: "Issue Panel",
          allow_picture: "Allow Picture?"
        },
        call_attempt: {
          from_inbound: "Inbound",
          live_transfer: "Eligible for Transfer",
          "transferred?": "Transferred"
        },
        call_center: {
          transfer_limit: "Voice Transfer Limit"
        },
        duplicate_call_program: {
          protection_period_days: "For x days",
          outreach_program_id: "Block patients from being called by this OP",
          outreach_program_ids_to_check: "If patients were scheduled to be called by the following OPs",
          only_successful: "Block only if previous attempts were successful",
          triggered_calls_only: "Check triggered calls only",
          requires_program_completion: "Block if previous attempts have not completed"
        },
        outreach_blockages: {
          outreach_program_ids: "Outreach Programs"
        },
        outreach_mass_enrollment: {
          launch_immediately: "Enroll and launch in a single outreach action?"
        },
        care_form: {
          display_completed_date: "Completed On"
        },
        enrollment_enroller: {
          target_ids: "Target Blueprints",
          targets_class: "Targets Class",
          condition: "Workflow Enrollment Trigger",
          patient_tags_action: "Tags Action"
        },
        workflow_status_change_reason: {
          status: "Workflow Status"
        },
        floorplans_settings: {
          automatic_pagination: "Automatic Pagination?",
          minimalist_view: "Minimalist View?",
          page_size: "Encounters Feed Page Size",
          script_id: "Rounding Script",
          show_patient_initials: "Show Patient Initials?",
          show_rounding_assignees: "Show Rounding Assignees?"
        },
        care_provider: {
          additional_roundable_information_fields: "Additional Information to Display Under Patient's Name",
          additional_staff_information_fields: "Additional Information to Display Under Staff's Name",
          additional_location_information_fields: "Additional Information to Display Under Location's Name",
          admitted_import_interval: "Alert about missing imports in new_files/admitted (interval in minutes)",
          advisor_email: "Customer Success Manager Email",
          advisor_name: "Customer Success Manager",
          allow_only_one_active_session: "Allow user to have only one active session",
          allow_parallel_chunk_processing: "Allow Parallel Chunk Processing?",
          allow_send_sms_reminder: "Allow to send SMS reminder?",
          atlas_enforce_lockout_after_failed_sign_in_attempts: "Enforce Lockout After Failed Sign-In Attempts",
          auto_imports_enabled: "Enable Automatic Imports?",
          auto_logout_hours: "Forced Logout X Hours after Login (Mobile)",
          calculate_health_score_daily: "Calculate Health Score and Star Rating Daily?",
          color: "Background color for email headers",
          care_notes_access: "Care Notes Access (Mobile)",
          care_provider_system: "Care Provider System",
          cc_author_on_round_summary_emails: "Copy Rounder on Round Summary Emails",
          cc_caregram_author_on_caregram_emails: "Copy Care Gram Sender On Care Gram Emails",
          cc_caregram_recipient_manager_on_caregram_emails: "Copy Care Gram Recipient Managers On Care Gram Emails",
          clear_similar_currently_admitted_encounters: "Clear Previous Currently Admitted Encounters For The Same Room And Bed",
          connect_to_epic_sandbox: "Epic Sandbox Environment?",
          consider_opt_out_as_reached: "Consider Opt Out as Reached",
          disable_caregram_emails: "Disable Sending Care Gram Emails?",
          display_assignee_filter: "Display Assignees on Rounding page",
          display_full_staff_rounding_timestamps: "Display Full Rounding Timestamps",
          due_soon_includes_overdue: "Due Soon includes Overdue?",
          enable_orchid_badges: "Enable Orchid Badges (Mobile)",
          encounter_api_fields: "Encounter information for Encounter Info Section (Mobile)",
          expire_echo_access: "Expire Care Recordings Access (days)",
          expire_echo_api_message: "Expired Care Recordings Access Message (Patient UI)",
          expire_echo_inbound_call_message: "Expired Care Recordings Access Message (Inbound Call)",
          echo_settings: {
            additional_question_issue_panel_id: "Issue Panel for additional questions",
            additional_question_issue_alert_id: "Issue Alert for additional questions",
            embeddable_echo_disclaimer_message: "Embeddable Care Recordings Disclaimer Message",
            embeddable_echo_expiration_minutes: "Embeddable Care Recordings Expiration Minutes",
            embeddable_echo_key: "Embeddable Care Recordings Key",
            embeddable_echo_key_mode: "Embeddable Care Recordings Key Mode"
          },
          enable_alert_management: "Enable Alert Management?",
          enable_barcode_scanning_for_location_rounding: "Enable Barcode Scanning For Location Rounding?",
          enable_convo_integration: "Enable Caregiver Engagement?",
          enable_caregram_recipient_autocomplete: "Enable Care Gram Recipients Autocomplete",
          enable_patient_dynamic_data_simulation: "Enable Patient Dynamic Data Simulation (Admittance and Discharge)",
          enable_patient_prioritization: "Enable Patient Prioritization?",
          enable_prisma_health_riskonnect_url: "Enable Prisma Health Riskonnect URL?",
          enable_staff_hierarchy: "Enable Staff Hierarchy?",
          enable_staff_on_duty_status: "Enable Staff On Duty Status?",
          enable_staff_rewards: "Enable Staff Rewards?",
          enable_staff_pronouns: "Include staff member's pronouns in rounding workflows",
          enable_patient_preferred_name: "Include patient's preferred name in rounding workflows",
          enable_patient_preferred_pronouns: "Include patient's pronouns in rounding workflows",
          encounter_form_fields: "New Encounter Form Fields",
          enforce_lockout_after_failed_sign_in_attempts: "Enforce Lockout After Failed Sign-In Attempts",
          enrollment_form_fields: "New Enrollment Form Fields",
          generate_rounding_summary_ai: "Enable AI Summaries for Patients",
          generate_staff_rounding_summary_ai: "Enable AI Summaries for Staff Members",
          failed_sign_in_limit: "Failed Sign-in Limit",
          file_alert_contacts: "Alert IT Contacts",
          force_email_tls: "Force SMTP server to use TLS",
          full_name_reversed: "Display Last Name Before First Name",
          hl7_alert_contacts: "Alert IT Contacts",
          hl7_auto_exports_enabled: "Enable Outbound Messages?",
          hl7_auto_imports_enabled: "Enable Automatic Imports?",
          hl7_import_interval: "Maximal allowable interval between messages (in minutes)",
          hl7_ip: "HL7 IP",
          hl7_live: "Live?",
          hl7_name: "HL7 Name",
          hl7_night_time: "HL7 Idle Hours",
          hl7_outbound_app: "HL7 Outbound Application Name",
          hl7_outbound_use_trailing_return: "Use a Trailing Carriage Return in HL7 messages",
          hl7_outbound_facility: "HL7 Outbound Facility",
          hl7_outbound_ip_address: "HL7 Outbound IP Address",
          hl7_outbound_port: "HL7 Outbound Port",
          hl7_purge_interval: "Purge Imports Interval (in days)",
          ignore_script_access: "Override Script Permissions to Show Historical Patient Interactions",
          import_interval: "Alert about missing imports in new_files (interval in minutes)",
          import_notifications: "Notify when Importing",
          in_app_survey_modal_enabled: "Product Usage Survey - User Function, Role, Title",
          inactive_user_deactivation_days: "Inactive User Deactivation (days)",
          integration_enabled: "Enabled",
          integration_token_expiration: "Expiration Of Patient Access Token (in minutes)",
          interaction_history_endpoint_types: "Interaction History Endpoint Types (Mobile)",
          interactions_endpoint_limit: "CipherRounds Interactions Endpoint Limit (Mobile)",
          last_rounding_timestamp_display_option: "Show Last Rounded Timestamp for Patient Rounding",
          log_out_interval: "CipherRounds Log Out Interval",
          log_out_interval_activated: "Forced Logout after X Minutes of Inactivity (Mobile)",
          logout_on_quit: "Forced Logout when app is closed/killed (Mobile)",
          notification_upon_login: "Notification Upon Login",
          notify_negative_answer: "Negative Answer Notification",
          only_count_open_rounding_issues_for_patient: "Only Count Open Rounding Issues for Patient",
          optimize_imports_enabled: "Enable Partial Imports?",
          orchid_combine_room_and_bed: "Combine Room and Bed Values Into Room Field",
          orchid_sso_federated_logout: "Enable Federated Single Logout (Mobile)",
          outbound_call_outreach_action_id: "Outbound Outreach Program for Care Recordings Sales Demo",
          password_change_interval: "Password Expiration Interval (days)",
          password_reset_link_expiration_interval: "Password Reset Link Expiration (hours)",
          patient_api_fields: "Patient information for Patient Info Section (Mobile)",
          patient_form_fields: "New Patient Form Fields",
          permanent_caregram_recipient_emails: "Permanent Care Gram Recipients Emails",
          phi_level: "Patient Name and Room Formatting",
          prompt_users_for_feedback: "Prompt Users for Feedback",
          prompt_users_for_feedback_days: "Days to Ask User for Feedback",
          prompt_users_for_feedback_text: "Text of the Feedback Request",
          public_key: "Public Key(s)",
          return_full_interactions_history: "Override Unit Criteria to Show Historical Patient Interactions",
          room_and_bed_show_options: "Display Options for CipherRounds Room and Bed Fields",
          sales_lead_email: "Sales Lead Email",
          salesforce_top_level_account_id: "Salesforce Top Level Account",
          send_department_short_name: "Display Staff Department Short Names Instead of Department Names",
          send_location_last_round_timestamp: "Display Location Rounding Script Specific Last Rounded Timestamps",
          send_mrn: "Send MRN for Barcode Scanning (Mobile)",
          send_patient_last_round_timestamp: "Display Patient Rounding Script Specific Last Rounded Timestamps",
          send_sso_invite_email: "Send SSO Invite Email",
          send_staff_last_round_timestamp: "Display Staff Rounding Script Specific Last Rounded Timestamps",
          setup_notes: "Notes",
          sftp_password: "SFTP Password",
          sftp_source_ip_address: "Source IP Address",
          sftp_type: "SFTP Type",
          sftp_username: "SFTP Login",
          sftp_host: "SFTP Hostname",
          sftp_data_upload_directory: "SFTP Upload Directory",
          sftp_login: "SFTP Login",
          short_name: "Short Name",
          show_add_patient: "Show Add Patient Button",
          show_add_staff_member: "Show Add Staff Member Button",
          show_caregram_history: "Show Care Grams History?",
          show_patient_page_users_online: "Show online users on patient and staff page",
          show_unit_visits: "Show Unit Visits (Mobile)",
          staff_member_api_fields: "Staff Member Information for Staff Info Section (Mobile)",
          location_api_fields: "Location Information for Location Info Section (Mobile)",
          location_rounding_page_count: "Location Rounding Page Count",
          support_email: "Support Email",
          threshold_for_rounding_post_discharge: "Threshold to Round on Recently Discharged Patients",
          time_zone: "Time Zone",
          token: "Current Integration Token",
          touch_login: "Allow Biometric Login (Mobile)",
          use_atlas_search: "Use New Patient Search Page",
          use_referral_source: "Use Referral Source?",
          use_remote_search_for_patient: "Enable remote search for patients in CipherRounds for this Care Provider",
          use_remote_search_for_staff: "Enable remote search for staff members in CipherRounds for this Care Provider",
          use_unit_facility_in_name: "Display Facility Next to Unit Names or Short Names",
          use_unit_short_name: "Display Unit Short Names Instead of Unit Names",
          use_facility_short_name: "Display Facility Short Names Instead of Facility Names",
          use_react_pages: "Use React Pages?",
          use_slick_pages: "Use Slick Pages?",
          user_invitation_form_fields: "New User Invitation Form Fields",
          user_timeout: "User Timeout (in minutes)"
        },
        users_activity_settings: {
          enabled: "Enable Automated Users Activity Log Export",
          remote_type: "External server type",
          remote_host: "FQDN or IP address of external server",
          remote_login: "External server login",
          remote_password: "External server password",
          remote_path: "External server exports path"
        },
        hl7_settings: {
          ascended: "Migrated to new architecture?",
          hl7_alert_contacts: "Alert IT Contacts",
          hl7_auto_imports_enabled: "Enable Automatic Imports?",
          hl7_import_interval: "Maximal allowable interval between messages (in minutes)",
          hl7_live: "Live?",
          hl7_purge_interval: "Purge Imports Interval (in days)",
          hl7_ip_addresses: "HL7 IP Addresses",
          hl7_names: "HL7 Names"
        },
        orchid_badge: {
          active: "Active?"
        },
        claim: {
          admit_count: "Admit Count",
          admit_key: "Admit Key",
          age_bracket: "Age Bracket",
          aid_category: "Aid Category",
          claim_key: "Claim Key",
          cms_revenue: "CMS Revenue",
          days_count: "Days Count",
          drg_code: "DRG Code",
          drg_description: "DRG Description",
          emergency_room_category: "Emergency Room Category",
          end_of_month: "End of Month Date",
          gpi_code: "GPI Code",
          gpi_description: "GPI Description",
          hcpcs_cpt_code: "HCPCS CPT Code",
          hcpcs_cpt_code_description: "HCPCS CPT Code Description",
          member_id_base: "Member Identifier Base",
          member_key: "Member Key",
          ndc_code: "NDC Code",
          ndc_description: "NDC Description",
          npi_number: "NPI Number",
          paid_amount: "Paid Amount",
          paid_at: "Paid Date",
          place_of_service_category: "Place of Service Category",
          primary_discharge_diagnosis_code: "Primary Discharge Diagnosis Code",
          primary_icd_procedure_code: "Primary ICD Procedure Code",
          product: "Product",
          provider_name: "Provider Name",
          provider_id: "Provider ID",
          provider_organization_name: "Provider Organization Name",
          provider_specialty: "Provider Specialty",
          provider_specialty_code: "Provider Specialty Code",
          provider_specialty_type: "Provider Specialty Type",
          provider_specialty_type_code: "Provider Specialty Type Code",
          readmission: "Readmission?",
          risk_score: "Risk Score",
          service_category: "Service Category",
          service_from: "Service From",
          service_to: "Service To",
          state_revenue: "State Revenue",
          tax_id: "Tax ID",
          total_revenue: "Total Revenue",
          visit_count: "Visit Count"
        },
        custom_converter: {
          mapped_values: {
            old_value: "Value",
            default: "Use as fallback mapping"
          }
        },
        department: {
          outreach_eligible: "Outreach Eligible?",
          reference_id: "Reference ID",
          roundable: "Roundable?",
          short_title: "Short Title",
          test_department: "Test Department",
          phonetic_spelling: "Phonetic Spelling",
          phonetic_spelling_audio_messages: "Department Name Audio"
        },
        unit: {
          building_code: "Building Code",
          short_title: "Short Title",
          unit_type: "Unit Type",
          roundable: "Roundable?",
          test_unit: "Test Unit",
          time_zone: "Time Zone",
          phonetic_spelling: "Phonetic Spelling"
        },
        rounding_flag: {
          name: "Name",
          color: "Color",
          description: "Description",
          criteria: "Criteria",
          archived: "Archived"
        },
        conditional_format: {
          text_color: "Text Color",
          background_color: "Background Color"
        },
        community_resource: {
          name: "Organization Name",
          pcp_name: "PCP Name",
          pcp_phone: "PCP Phone",
          website: "Email/Website",
          accepting_patients: "Accepting Patients",
          service_type: "Service Type",
          insurances_accepted: "Insurances Accepted"
        },
        criteria: {
          sign: "Operator",
          chain: {
            criterium: {
              sign: "Operator"
            }
          }
        },
        data_generation: {
          patient_units: "Located In",
          patient_phones: "Phone Numbers",
          patient_programs: "Enrolled In",
          patient_programs_mode: "",
          patient_rounding_author: "",
          patient_rounding_scripts: "Rounded With",
          patient_rounding_create_issues: "",
          patient_admitted_percentage: "Admitted %",
          issues_close_percentage: "Close Issues %",
          issues_attempt_percentage: "Attempt Issues %",
          unit_transfer_units: "Units",
          unit_transfer_percentage: "Transfer %",
          unit_ids: "Located In",
          phones: "Phone Numbers",
          outreach_program_ids: "Enrolled In",
          rounding_script_ids: "Rounded With",
          rounding_author_id: "Rounding Author",
          admitted_percentage: "Admitted %"
        },
        transfer_simulation: {
          unit_ids: "Units",
          transfer_percentage: "Transfer %"
        },
        issue_simulation: {
          close_percentage: "Close Issues %",
          attempt_percentage: "Attempt Issues %"
        },
        data_view: {
          name: "Name",
          _type: "Type",
          alert_recipient_only: "Alert Recipient Only",
          allow_column_load_optimization: "Allow Column Load Optimization",
          always_display_total: "Always Display Total?",
          combine_similar_script_questions: "Combine Similar Questions",
          data_fields: "Fields",
          program_fields: "Program Fields",
          script_questions: "Script Questions",
          issue_summaries: "Issue Summaries",
          issue_panel_fields: "Issue Fields",
          care_form_controls: "Care Form Controls",
          default_search: "Default Search",
          disable_mass_actions: "Disable Mass Actions?",
          export_one_care_gram_per_recipient: "Export One Care Gram Per Email Recipient?",
          interaction_author_only: "Interaction Author Only",
          interaction_status: "Interaction Status",
          only_with_free_responses: "Only with Free-Text/Free-Voice responses?",
          restrict_external_queries_threshold: "Restrict External Queries Threshold",
          show_all_issues: "Show All Issues?",
          deprecated_lookback_days: "Issues Lookback Days",
          sort_by_discharge: "Sort Results by Discharge Date?",
          auto_refresh_enabled: "Enable Auto-Refresh",
          refresh_timer_seconds: "Refresh Timer (In Seconds)"
        },
        data_exchange_export_job: {
          auto_archive: "Auto-Archive?",
          collapse_new_lines: "Collapse New Lines",
          data_filter_field: "Data Filter",
          data_since: "Export Data Since",
          data_view_class: "Data View Class",
          data_view_id: "Data View",
          encoding: "Encoding",
          extension: "File Extension",
          filename: "Filename",
          first_export_at: "First Export At",
          frequency: "Frequency",
          gpg_public_key: "GPG Public Key",
          gpg_recipient_email: "GPG Recipient Email",
          lookback_days: "Lookback (in days)",
          mode: "Export Format",
          next_export_at: "Next Export At",
          recipient_ids: "Recipients",
          recurrence_mode: "Recurrence Mode",
          skip_header: "Skip Header?",
          status: "Status",
          type: "Export Type",
          zip: "Zip?",
          lock_status: "Lock Status?",
          time_critical: "Time Critical?",
          export_xslt_enabled: "Enable XSLT Transformations?",
          export_xslt: "XSLT used for the transformation"
        },
        data_exchange_file_import: {
          post_import_script_class: "Post Import Script",
          sftp_filename: "CSV File",
          sftp_dirname: "Add to Directory",
          mappings: {
            has_header: "Skip Header Row?"
          }
        },
        data_exchange_night_time_info: {
          all_day: "Day Range"
        },
        data_exchange_readmission_import: {
          outreach_program_ids: "Outreach Programs"
        },
        diagnosis: {
          end_date: "End Date",
          icd_code_version: "ICD Code Version",
          icd_code: "ICD Code",
          name: "Name",
          related_encounter_id: "Rel. Encounter ID",
          start_date: "Start Date",
          status: "Status"
        },
        hl7_mapping_association: {
          mappings: {
            hl7_field: "HL7 Field",
            converter_ids: "Converters"
          }
        },
        echo_encounter: {
          recording_type: "Recording Type"
        },
        encounter: {
          act_as_unit_for_orchid: "Act as unit for Orchid?",
          admit_reason: "Admit Reason",
          admit_source: "Admit Source",
          admitting_diagnosis: "Admitting Diagnosis",
          appointment_location_resource: "Appointment Location",
          appointment_person_resource: "Appointment Person",
          arrival_date: "Arrival Date",
          attending_id: "Attending ID",
          attending_physician: "Attending Physician",
          audio_instruction: "Audio Instruction",
          audio_discharge_instruction: "Audio Discharge Instruction",
          bed_number: "Bed Number",
          care_gaps: "Care Gaps",
          case_date: "Case Date",
          clinic_name: "Clinic Name",
          chf_core_measure: "CHF Core Measure",
          chf_instructions: "CHF Instructions",
          currently_admitted: "Currently Admitted",
          device_code: "Device Code",
          diagnosis_related_group: "Diagnosis Related Group",
          discharge_date: "Discharge Date",
          discharge_disposition: "Discharge Disposition",
          discharge_reviewed_by: "Discharge Reviewed by",
          encounter_class: "Encounter Class",
          encounter_free_text_type: "Free Text Type",
          encounter_id: "Encounter ID",
          encounter_type: "Type",
          expected_arrival_date: "Expected Arrival Date",
          expected_discharge_date: "Expected Discharge Date",
          fall_risk: "Fall Risk",
          has_ami: "Has AMI?",
          has_chf: "Has CHF?",
          has_copd_asthma: "Has COPD-Asthma?",
          has_pneumo: "Has Pneumo?",
          has_sepsis: "Has Sepsis?",
          has_stroke: "Has Stroke?",
          has_central_line: "Has Central Line?",
          hospital_service: "Hospital Service",
          hospitalist_name: "Hospitalist Name",
          lead_surgeon: "Lead Surgeon",
          length_of_stay: "Length of Stay",
          medical_conditions: "Medical Conditions",
          medication_code: "Medication Code",
          mrn: "MRN",
          operation_length: "Operation Length",
          previous_discharge_date: "Previous Discharge Date",
          pending_transfer: "Pending Transfer",
          room: "Room",
          unit_telephone: "Unit Telephone",
          visit_provider: "Visit Provider",
          vip_status: "VIP Status",
          hedis: "HEDIS",
          adolescent_well_care_visits: "AWC - Adolescent Well-Care Visits",
          adult_bmi_assessment: "ABA - Adult BMI Assessment",
          annual_dental_visit: "ADV - Annual Dental Visit",
          asthma_medication_ratio: "AMR - Asthma Medication Ratio",
          breast_cancer_screening: "BCS - Breast Cancer Screening",
          cervical_cancer_screening: "CCS - Cervical Cancer Screening",
          childhood_immunization_status: "CIS - Childhood Immunization Status",
          comprehensive_diabetes_care: "CDC - Comprehensive Diabetes Care",
          controlling_high_blood_pressure: "CBP - Controlling High Blood Pressure",
          hedis_eligibility: "HEDIS Eligibility",
          immunizations_for_adolescents: "IMA - Immunizations for Adolescents",
          lead_screening_in_children: "LSC - Lead Screening in Children",
          medication_management_for_people_with_asthma: "MMA - Medication Management for People with Asthma",
          prenatal_and_postpartum_care: "PPC - Prenatal and Postpartum Care",
          supplemental_security_income_adult: "Supplemental Security Income - Adult",
          supplemental_security_income_child: "Supplemental Security Income - Child",
          well_child_visits_in_first_15_months: "W15 - Well-Child Visits in the First 15 Months of Life",
          well_child_visits_in_third_to_six_years: "W34 - Well-Child Visits in the Third, Fourth, Fifth, and Sixth Years of Life",
          patient_class: "Patient Class",
          payor_status: "Payor Status",
          pcp_phone: "PCP Phone",
          primary_care_physician: "Primary Care Physician",
          primary_discharge_diagnosis: "Primary Discharge Diagnosis",
          primary_nurse: "Primary Nurse",
          provider_patient_id: "MRN",
          alternate_provider_patient_id: "Alternate Patient ID",
          quartiary_discharge_diagnosis: "Quartiary Discharge Diagnosis",
          reason_for_visit: "Reason for Visit",
          readmit_timespan: "Readmit Timespan",
          resident_name: "Resident Name",
          risk_score_1_on_discharge: "Risk Score 1 on Discharge",
          risk_score_2_on_discharge: "Risk Score 2 on Discharge",
          risk_score_3_on_discharge: "Risk Score 3 on Discharge",
          secondary_discharge_diagnosis: "Secondary Discharge Diagnosis",
          secondary_nurse: "Secondary Nurse",
          secondary_procedure: "Secondary Procedure",
          surgical_encounter_status: "Surgical Encounter Status",
          surgical_location: "Surgical Location",
          surgical_service: "Surgical Service",
          tertiary_discharge_diagnosis: "Tertiary Discharge Diagnosis",
          total_charges: "Total Charges",
          unit_name: "Care Provider Unit",
          lace_score: "LACE Score",
          discharge_instruction: "Discharge Instruction",
          follow_up_info: "Follow Up Info",
          medication_info: "Medication Info",
          personal_message: "Personal Message",
          physician_message: "Physician Message",
          has_diabetes: "Has Diabetes?",
          foley_catheter: "Foley Catheter",
          cervical_cancer_gap: "Cervical Cancer Gap",
          colorectal_cancer_gap: "Colorectal Cancer Gap",
          breast_cancer_gap: "Breast Cancer Gap",
          diabetes_registry: "Diabetes Registry",
          last_office_visit_date: "Last Office Visit Date",
          next_visit_date: "Next Visit Date",
          almost_prime_eligible: "Almost PRIME Eligible",
          prime_population: "PRIME Population",
          surgical_site_infection: "Surgical Site Infection",
          epic_risk_score: "Epic Risk Score",
          readmission_risk: "Readmission Risk",
          readmission_risk_score: "Readmission Risk Score",
          episode_id: "Episode ID",
          episode_status: "Episode Status",
          bariatric_surgery: "Bariatric Surgery",
          admission_type: "Admission Type",
          prior_patient_location: "Prior Patient Location",
          feeding_intention: "Feeding Intention",
          delivery_date: "Delivery Date",
          delivery_type: "Delivery Type",
          delivery_result: "Delivery Result",
          insignia_sub_group_ext_id: "Insignia Sub Group Ext ID",
          hcahps_dissatisfaction_score: "Predicted to Be Dissatisfied?",
          department_reference_id: "Department Reference ID",
          visit_type_reference_id: "Visit Type Reference ID",
          visit_provider_reference_id: "Visit Provider Reference ID"
        },
        encounter_criterium: {
          name: "Name",
          description: "Description",
          action: "Action",
          priority: "Priority",
          criteria: "Criteria",
          issue_panel_id: "Issue Panel",
          issue_alert_id: "Issue Alert",
          patient_tag_ids: "Patient Tags",
          rounding_flag_id: "Rounding Flag",
          completion_view_blueprint_ids: "Target Workflows",
          view_blueprints_condition: "Enroll in Target Workflows",
          view_blueprint_ids: "Target Workflows"
        },
        enrollment: {
          active: "Active",
          attribution_status: "Attribution Status",
          alternate_member_id: "Alternate Member Id",
          subscriber_id: "Subscriber ID",
          member_id: "Member ID",
          pcp_id: "PCP ID",
          pcp_prefix: "PCP Prefix",
          pcp_suffix: "PCP Suffix",
          pcp_middle_name: "PCP Middle Name",
          pcp_phone_number: "PCP Phone Number",
          plan_effective_date: "Plan Effective Date",
          plan_termed_date: "Plan Termed Date",
          overall_coverage_start_date: "Overall Coverage Start Date",
          late_notification_date: "Late Notification Date",
          payer_pcp_first_name: "PCP First Name",
          payer_pcp_last_name: "PCP Last Name",
          npi: "NPI",
          specialist_npi: "Specialist NPI",
          specialist_prefix: "Specialist Prefix",
          specialist_first_name: "Specialist First Name",
          specialist_middle_name: "Specialist Middle Name",
          specialist_last_name: "Specialist Last Name",
          specialist_suffix: "Specialist Name Suffix",
          specialist_phone_number: "Specialist Phone Number",
          relationship_to_subscriber: "Relationship to Subscriber",
          group_id: "Group ID"
        },
        escalation: {
          title: "Name",
          issue_alerts: "Issue Alerts",
          require_reason: "Require reason for escalation"
        },
        facility: {
          teaching_status: "Teaching Status",
          profit_type: "Profit Type",
          location_type: "Location Type",
          bed_size: "Bed Size",
          inpatient_surgeries: "Inpatient Surgeries",
          part_time_staff: "Part-Time Staff",
          full_time_staff: "Full-Time Staff"
        },
        factor_conversion: {
          key: "Factor"
        },
        floorplan: {
          unit_id: "Unit"
        },
        goal: {
          text: "Goal"
        },
        help_material: {
          permission_tags: "Permission Tags"
        },
        import_association: {
          name: "Association Name",
          patient_matching: "Patient Matching",
          file_name_pattern: "File Name Pattern",
          post_import_script_class: "Post Import Script",
          unused_alert_threshold: "Unused Alert Days Threshold",
          mappings: "Mappings"
        },
        issue_alert: {
          alert_triggered_at: "Last Triggered On",
          invited_recipient_ids: "Invited Recipients",
          recipient_ids: "Recipients",
          rounding_model: "Alert For",
          send_on_issue_closed: "Send Issue Closed Alert",
          closed_subject: "Subject",
          closed_message: "Message",
          closed_plain_text_message: "Plain text message"
        },
        issue_panel: {
          short_name: "Short Name",
          show_related_interactions: "Show Related Interactions?",
          notify_after_closing: "Notify After Closing?",
          use_intervention_timer: "Use Intervention Timer?",
          show_triggering_response: "Show Only Triggering Responses?",
          rounding_model: "Panel For",
          issue_class: "Panel For"
        },
        issue_subpanel: {
          show_title: "Show Title?",
          improvement_area: "Improvement Area",
          call_status: "Call Status",
          clinical_feedback: "Clinical Feedback",
          follow_up_action: "Follow Up Action"
        },
        issue_subpanel_field: {
          caregram_template_id: "Caregram template",
          script_id: "Script"
        },
        key_metric_integration: {
          metric_type: "Metric Type",
          metric_unit: "Metric Unit",
          script_id: "Script"
        },
        key_metric_threshold: {
          value: "Limit",
          threshold_type: "Threshold Type"
        },
        location: {
          group_id: "Group",
          show_in_orchid: "Available for Rounding",
          tag_ids: "Tags",
          test_location: "Test Location?"
        },
        login_page_content: {
          url: "Homepage URL"
        },
        map_value: {
          old_value: "Value",
          default: "Use as fallback mapping"
        },
        medication: {
          prescription_date: "Prescription Date",
          dosage_unit: "Dosage Unit",
          dosage_value: "Dosage Value",
          end_date: "End Date",
          medication_code: "Medication Code (NDC)",
          prescribing_location: "Prescribing Location",
          prescription_id: "Prescription ID",
          quantity: "Quantity",
          quantity_unit: "Quantity Unit",
          name: "Name",
          related_encounter_id: "Rel. Encounter ID",
          start_date: "Start Date",
          status: "Status",
          refills: "Refills",
          offer_type: "Offer Type"
        },
        missed_calls: {
          hour: "Hour (UTC)"
        },
        new_interaction: {
          script_id: "Script"
        },
        observation: {
          started_at: "Date"
        },
        outbound_message_settings: {
          type: "Event Type",
          message_type: "HL7 Message"
        },
        patient: {
          additional_contact_information: "Additional Contact Information",
          attending_physician: "Attending Physician",
          caregiver_contact_information: "Caregiver Contact Information",
          contact_address: "Contact Address",
          contact_email: "Contact Email",
          contact_name: "Contact Name",
          contact_phone: "Contact Phone",
          contact_relationship: "Contact Relationship",
          date_of_birth: "Date of Birth",
          discharge_date: "Discharge Date",
          dnr: "DNR",
          ed_visit_count: "ED Visit Count",
          employee_id: "Employee ID",
          encounter_id: "Encounter",
          first_name: "First Name",
          health_insurance_type: "Health Insurance Type",
          health_plan_name: "Health Plan Name",
          insurance_company_name: "Insurance Company Name",
          insurance_bank_identification_number: "Insurance Bank Identification Number",
          insurance_group_number: "Insurance Group Number",
          insurance_member_id: "Insurance Member Id",
          insurance_processor_control_number: "Insurance Processor Control Number",
          inpatient_visit_count: "Inpatient Visit Count",
          last_name: "Last Name",
          link: "Name",
          marital_status: "Marital Status",
          medicaid_id: "Medicaid ID",
          middle_name: "Middle Name",
          multi_visit_patient: "Multi-Visit Patient",
          mrn: "MRN",
          other_payer: "Other Payer",
          other_policy_number: "Other Policy Number",
          patient_portal: "Patient Portal",
          patient_tag_ids: "Tags",
          phone: "Phone",
          polst: "POLST",
          preferred_contact_method: "Preferred Contact Method",
          preferred_name: "Preferred Name",
          preferred_outreach_language: "Preferred Outreach Language",
          preferred_pronoun: "Pronouns",
          primary_language: "Primary Language",
          primary_policy_number: "Primary Policy Number",
          religious_affiliation: "Religious Affiliation",
          secondary_payer: "Secondary Payer",
          secondary_phone: "Secondary Phone",
          secondary_policy_number: "Secondary Policy Number",
          tertiary_payer: "Tertiary Payer",
          tertiary_policy_number: "Tertiary Policy Number",
          test_patient: "Test Patient?",
          thirty_day_readmission: "30-Day Readmission",
          title: "Title",
          tobacco_use: "Tobacco Use",
          unit_name: "Unit",
          suffix: "Suffix",
          employment_status: "Employment Status",
          aco_mssp_indicator: "ACO MSSP Indicator",
          other_insurance_indicator: "Other Insurance Indicator",
          enrollment_indicator: "Enrollment Indicator"
        },
        password_requirements: {
          minimum_length: "Minimum Length",
          different_than_recent: "Enforce Password History",
          caps: "Caps Character Required",
          special: "Special Character Required",
          numeric: "Numeric Character Required",
          disallow_similar: "Disallow Similar Passwords",
          cannot_be_email: "Cannot Be The Same As E-Mail",
          cannot_contain_email: "Cannot Contain The E-Mail",
          cannot_be_user_name: "Cannot Be The Same As User Name",
          cannot_contain_user_name: "Cannot Contain The User Name"
        },
        insights_dashboard: {
          dashboard_id: "Dashboard ID"
        },
        pulse: {
          anonymous: "Anonymous?"
        },
        recurrence: {
          frequency: "Repeats",
          interval: "Repeat every",
          started_on: "Starts on",
          ending_type: "Ends",
          ended_on: "Ends on",
          occurrences_number: "Occurrences"
        },
        referral: {
          referral_id: "Referral ID",
          referred_to_provider_id: "Referred to provider ID",
          referred_to_department_id: "Referred to department ID"
        },
        orchid_settings: {
          phi_level: "Display Name",
          allow_touch_login: "Allow Biometric Login",
          biometric_login_expiration_days: "Biometric Login Expiration Interval"
        },
        outreach_action: {
          allow_reenrollment: "Allow Re-enrollment",
          expiration_shift: "Inbound Expiration (days)",
          gemini_tts_voice_talent: "Populate missing audio with Gemini TTS",
          manual_issue_panel_id: "Issue Panel",
          max_early_hangups: "Maximum Number of Hang Ups",
          max_early_hangups_abort_mode: "Hang Ups Abort Mode",
          unlimited_inbound_expiration: "Unlimited Inbound Expiration (days)"
        },
        question: {
          answers: {
            appointment_action: "Outbound Message Type"
          }
        },
        outreach_program: {
          allow_attempts_after_successful_sms_delivery: "Allow Additional Channel Series Attempts After Successful SMS Delivery",
          allowable_call_days: "Allowable Outreach Days",
          non_allowable_days_fallback: "Non-allowable Days Fallback",
          disable_engagement_on_non_allowable_days: "Disable engagement on non-allowable call days",
          extended_call_hours_support: "Extended call hours support",
          best_practice: "Best practice?",
          confidential: "Confidential",
          completed_message: "Completed Interaction Message (Call)",
          consider_voicemail_as_reached: "Consider Voicemail as Reached",
          custom_call_hours_range: "Quick Add Custom Call Hours Range",
          do_not_play_outreach_questions: "Don't play rest of OA",
          enforce_first_medical: "Enforce First Medical",
          enrollment_alert_shift: "No Patients Enrolled (Time Since Last Enrollment) Alert",
          enrollment_alerts_on_first_hour: "First Outreach Hour Alert",
          enrollment_count_limits_mode: "Enrollment Count Limits Mode",
          enrollment_timeframe: "Enrollment Timeframe",
          expected_enrollment_days: "No Patients Enrolled (Day of Week) Alert",
          forbidden_days: "No Outreach On These Dates",
          holidays: "Outreach On These Holidays",
          inactive_program_message: "Inactive Message",
          inbound_allow_test_call: "Allow Test Inbound Calls",
          inbound_intro_audio_message: "Inbound Intro Audio Message",
          inbound_intro_generated_audio_script: "Inbound Intro Generated Audio Script",
          inbound_mismatch_message: "Inbound Mismatch Message",
          inbound_mismatch_generated_audio_script: "Inbound Mismatch Generated Audio Script",
          completed_generated_audio_script: "Completed Generated Audio Script",
          inactive_program_generated_audio_script: "Inactive Program Generated Audio Script",
          transfer_not_available_generated_audio_script: "Transfer Not Available Generated Audio Script",
          call_screening_introduction_generated_audio_script: "Call Screening Introduction Generated Audio Script",
          closing_generated_audio_script: "Closing Generated Audio Script",
          inbound_test_outreach_action_id: "Inbound Test Outreach Action",
          launch_active_call_center_only: "Launch Calls Only If Department's Call Center Is Active",
          outreach_use_case: "Configuration Type",
          phone: "Default Phone Number",
          program_type: "Program Type",
          prompt_reach_delay_seconds: "Prompt Reach Launch Delay (seconds)",
          reminder_type: "Reminder Type",
          remove_outbound_on_successful_inbound: "Remove Patient From Outbound Calls",
          sender_email: "Sender Email Address",
          skip_past_outreach_actions: "Skip Outreach Actions When Enrollment Occurs After the Shift Date",
          sms_alert_message: "SMS Alert Message",
          sms_alert: "SMS Alert",
          sms_completed: "Completed Interaction Message (SMS)",
          sms_reminder_message: "SMS Reminder Message",
          sms_reminder: "SMS Attempt 24-Hour Reminder",
          sms_short_code: "SMS Short Code",
          solution_type: "Solution Type",
          use_department_phone: "Use Department Phone",
          voice_talent: "Voice Talent",
          multiple_enrollment: "Single Encounter Multiple Enrollment",
          webform_completed: "Completed Interaction Message (Webform)"
        },
        voice_talent: {
          audio_talent: "Voice Talent",
          language: "Language",
          tone_profile: "Tone Profile"
        },
        custom_call_hour: {
          facility_or_department_group: "Facility or Dept Group"
        },
        patient_prioritization_factor_program: {
          default: "Default Setting",
          factor_mappings: "Factor Conversions",
          key: "Factor",
          weight: "Factor Weight"
        },
        outreach_custom_playback_field: {
          name: "Name",
          description: "Description",
          default_text: "Default Text",
          default_audio: "Default Audio",
          default_language: "Language",
          default_generated_audio_script: "Generated Audio Script",
          language: "Language",
          generated_audio_script: "Generated Audio Script",
          text: "Text",
          audio: "Audio",
          order: "Order",
          criteria: "Criteria"
        },
        patient_tag: {
          for_tagging_rules: "For Tagging Rules Only",
          warn_when_tagged: "Warn when Tagged"
        },
        pentaho_report: {
          name: "Report Name",
          path: "Report Path"
        },
        readmission_import: {
          outreach_program_ids: "Outreach Programs",
          encounters_count: "# Encounters",
          created_at: "Uploaded At",
          user_email: "Uploaded By"
        },
        related_settings: {
          allow_send_sms_reminder: "Allow to send SMS reminder?",
          calculate_health_score_daily: "Calculate Health Score and Star Rating Daily?",
          due_soon_includes_overdue: "Due Soon includes Overdue?",
          thresholds_check_time: "Thresholds Check Time",
          use_referral_source: "Use Referral Source?",
          referral_sources: "Referral Sources",
          secondary_referral_sources: "Secondary Referral Sources",
          task_categories: "Task Categories"
        },
        report_package: {
          hour: "Hour (EST)",
          template_id: "Template",
          type: "Frequency",
          subject: "Email Subject",
          unsubscribe_reason: "Would you like to tell us why?"
        },
        rounding_script: {
          location: "Location",
          shared: "Show in the Library?",
          ambient_listening: "Ambient Listening",
          collaborative: "Collaborative",
          anonymous_survey: "Anonymous Survey?",
          collect_contact_information_survey: "Collect contact information on negative response?",
          custom_finished_script_text: "Custom text after Survey is submitted?"
        },
        role: {
          patient_list_config_ids: "Patient Lists",
          rounding_dashboard_ids: "Rounding Dashboards",
          insights_dashboard_ids: "Insights Dashboards"
        },
        rule: {
          call_status: "call status",
          issue_panel_id: "issue",
          issue_count_filter_enabled: "Enable issue count filter?",
          unresolved_issue_panel_id: "issue",
          unattempted_issue_panel_id: "issue",
          issue_alert_id: "alert",
          outreach_action_id: "outreach action",
          minutes: "minutes",
          hours: "hours",
          days: "days",
          times: "times",
          completed_program_id: "Outreach Program",
          enroll_in_program_id: "program",
          observation_result_name: "observation result",
          key_metric_type: "key metric",
          key_metric_unit: "unit",
          outreach_program_ids: "programs",
          created_by: "sources",
          reenroll_in_program: "to reenroll",
          repeats: "repeats",
          rounding_flag_id: "rounding flag",
          unit_ids: "units"
        },
        import_rule: {
          import_association_id: "association"
        },
        sso_connection: {
          care_provider_ids: "Care Providers",
          enabled: "Enable SSO Connection",
          logout_url: "Logout URL",
          search_user_by_field: "Search SSO User by Field",
          slug: "SSO Login Shortcut Path",
          connection_type: "Connection Type",
          domains: "SSO Domains",
          test_emails: "Test Emails"
        },
        ssr_script: {
          reporting_name: "Reporting Name",
          solution_type: "Solution Type",
          program_type: "Program Type",
          status: "Status"
        },
        staff_member: {
          always_allow_caregrams: "Always Allow Caregrams?",
          employee_id: "Employee ID",
          employee_status: "Employee Status",
          employment_classification: "Employment Classification",
          healthcare_role: "Healthcare Role",
          hire_date: "Hire Date",
          on_duty: "On Duty?",
          pay_grade: "Pay Grade",
          photo_filename: "Photo Filename",
          show_in_orchid: "Available for Rounding",
          show_in_kiosk: "Show in Kiosk Staff Questions?",
          staff_department_id: "Staff Department",
          staff_department_number: "Staff Department Number",
          survey_location_ids: "Survey Locations",
          title: "Job Title",
          reports_to_staff_member_ids: "Reports to staff members",
          test_staff_member: "Test Staff?"
        },
        staff_reward: {
          type: "Gift Card Provider",
          value: "Reward Amount"
        },
        survey_device: {
          login_id: "Login ID",
          rounding_script_ids: "Surveys",
          survey_location_id: "Location",
          inventory_tag: "Inventory Tag"
        },
        survey_promotion: {
          survey_location_ids: "Kiosk Locations",
          survey_script_ids: "Surveys"
        },
        survey_reputation_email: {
          survey_location_id: "Kiosk Location"
        },
        survey_settings: {
          email_message_text: "Email message text",
          sms_message_text: "SMS message text",
          notification_resent_delay: "Incomplete Survey Reminder"
        },
        task: {
          date: "Due Date",
          due_time: "Due Time",
          description: "Description",
          require_notes: "Require Notes",
          skill_set: "Skill-Set",
          start_date: "Start Date",
          start_time: "Start Time",
          time_needed: "Time Needed"
        },
        team_member: {
          name: "Team Member"
        },
        user: {
          alert_user: "Alert-Only User?",
          provider_info: {
            after_sign_in_url: "After sign in redirect url"
          },
          sso_connection_id: "SSO Connection Name",
          sso_connection: "SSO Connection Name",
          sso_emails: "SSO Emails",
          sso_status: "SSO Status",
          sso_username: "SSO Username",
          staff_member_id: "Staff Member",
          test_user: "Test User?",
          two_factor_authentication_code: "Two Factor Authentication Code",
          profile_picture: {
            image: "Photo"
          }
        },
        user_info: {
          alert_channels: "Delivery Methods"
        },
        user_invitation: {
          sso_enabled: "SSO Enabled?",
          sso_username: "SSO Username"
        },
        user_configuration: {
          sso_status: "Enable SSO?"
        },
        user_copy: {
          invite_new: "Select what you want to do",
          email: "Please enter the email of the user you want to copy the settings to",
          alerts: "Also assign the user to the following alerts"
        },
        view_blueprint: {
          faq_topic_ids: "FAQ Topics",
          link_blueprint_id: "Link Blueprint",
          service_request_configuration_ids: "Service Requests",
          type: "Product Type"
        },
        visit_provider: {
          outreach_eligible: "Outreach Eligible?",
          phonetic_spelling: "Phonetic Spelling",
          provider_id: "Provider ID",
          reference_id: "Reference ID",
          resource_type: "Resource Type"
        },
        visit_type: {
          outreach_eligible: "Outreach Eligible?",
          phonetic_spelling: "Phonetic Spelling",
          reference_id: "Reference ID",
          visit_type_groups: "Visit Type Groups"
        },
        visit_type_group: {
          reference_ids: "Visit Type Reference IDs"
        },
        widget_configuration: {
          rounding_script_id: "Rounding Script"
        },
        workflow: {
          link: "Name",
          enrollment_date: "Enrollment",
          blueprint: "Plan"
        },
        template: {
          type: "Product",
          plans_count: "Enrollments"
        },
        whitelist_ip_address: {
          ip_address: "IP Address",
          temporary_ip_address: "Temporary IP Address?"
        },
        web_based_configuration: {
          slug: "URL Slug",
          enable_resuming_surveys: "Enable Resuming Surveys for Web Based Programs",
          enable_self_service_rounding: "Enable SMS for Web-Based Programs?",
          enable_self_service_rounding_view_columns: "Enable Data View Columns for Web-Based Programs?",
          self_rounding_api_environment: "Self-Service Rounding API Environment",
          opening_message: "Opening",
          welcome_message: "Welcome Message",
          home_screen_message: "Home Message",
          language_ids: "Languages",
          staff_opening_message: "Opening",
          staff_welcome_message: "Welcome Message",
          staff_home_screen_message: "Home Message",
          staff_language_ids: "Languages",
          staff_anonymous_mode_enabled: "Anonymous Mode"
        },
        web_based_theme: {
          avatar_fill_color: "Chat Avatar Fill Color",
          color_primary: "Primary Color",
          landing_page_background_color: "Home Screen Background Color"
        },
        web_based_program: {
          program_type_label: "Program Type",
          solution_type_label: "Solution Type",
          messaging_service_id: "Messaging Service SID",
          display_new_status: "Enable 'New' Status",
          display_in_progress_status: "Enable 'In-Progress' Status",
          enabled: "Enable SMS",
          message: "Outbound Message",
          inbound_response_message: "Inbound Message",
          is_anonymous: "Allow Anonymous Responses For This Program",
          survey_access_in_care_from: "How many days post-admit can patients access this survey",
          survey_access_in_care_to: "Up to (days)",
          survey_access_pre_care_from: "How many days before a visit can patients access this survey?",
          survey_access_pre_care_to: "Up to (days)",
          survey_access_post_care_from: "How many days post-visit or post-discharge can patients access this survey?",
          survey_access_post_care_to: "Up to (days)",
          staff_survey_access: "Survey Availability Dates"
        },
        web_based_question_unlocking_rule: {
          id: "Answering this question",
          answers: "With following answer(s)"
        },
        web_based_answers: {
          response: "Response to this answer"
        },
        web_based_answers_alerts: {
          selected_answers: "Add to",
          add_on_id: "Alert"
        },
        web_based_answers_issues: {
          selected_answers: "Add to",
          add_on_id: "Issue"
        },
        web_based_answers_flag_rules: {
          field_name: "This answer will",
          selected_answers: "Add to",
          add_on_id: "Flag"
        }
      },
      hints: {
        defaults: {
          quick_task: "The task will be added to the connected Workflow if a Key Metric is out of the threshold's limit.",
          rounding_script_ids: "Select the rounding scripts that the user should be able to use."
        },
        atlas_faq: {
          answer: "This field supports markdown text."
        },
        audio_clip: {
          transcription: "The content of the audio file as plain text."
        },
        call_center: {
          sms_launch_limit: "This number will be how many SMS attempts are sent every 10 minutes in an active call hour. The total number of SMS attempts launched in an hour will be this approximate number multiplied by 6."
        },
        web_based_configuration: {
          slug: "Input is restricted to only letters, numbers, hyphens, and underscores.",
          enable_resuming_surveys: "This setting allows a patient or staff member to resume in-progress surveys. Note: Staff submitting surveys anonymously can never resume a survey regardless of this setting being on.",
          patient_generated_url: "This is the URL and QR code that is used for all Patient Web-Based programs. Only one URL and QR code is generated per Care Provider.",
          staff_generated_url: "This is the URL and QR code that is used for all Staff Web-Based programs. Only one URL and QR code is generated per Care Provider.",
          opening_message: "This message is what displays on the Authentication page.",
          welcome_message: "This message is what displays on the Authentication page under the Opening.",
          home_screen_message: "This message is what displays on the survey card page. This message displays above the available cards",
          language_ids: "These are the languages that will be available in the dropdown on the top right corner of the Authentication, Home Page, and Survey. When a language is selected, all pages will display in the chosen language. If no language is configured here, English will be the only available language.",
          staff_opening_message: "This message is what displays on the Authentication page.",
          staff_welcome_message: "This message is what displays on the Authentication page under the Opening.",
          staff_home_screen_message: "This message is what displays on the survey card page. This message displays above the available cards",
          staff_language_ids: "These are the languages that will be available in the dropdown on the top right corner of the Authentication, Home Page, and Survey. When a language is selected, all pages will display in the chosen language. If no language is configured here, English will be the only available language.",
          staff_anonymous_mode_enabled: "When this setting is configured, the anonymous checkbox will be available on the Authentication Page.",
          enable_self_service_rounding_view_columns: "When this setting is enabled, web based program questions can be pulled into data views.",
          self_rounding_api_environment: "Used to allow the Evolve develop environment to connect to different instances of the Self Rounding API environment. Only available in develop for testing purposes."
        },
        web_based_feedback_program: {
          question: "This is what will display when a web-based program has this question enabled on the script. This question is asking about the users experience with the tool."
        },
        claim: {
          admit_count: "An indicator that is \"1\" when the claim is considered an admit, \"0\" otherwise.",
          admit_key: "A data warehouse assigned value to uniquely identify the admission.",
          age_bracket: "Customized age brack to align with internal reporting, if it is available.",
          aid_category: "A field specifying the level of support required for the patient.",
          claim_key: "A data warehouse assigned value to uniquely identify the claim.",
          cms_revenue: "Amount paid to Insurer by CMS.",
          days_count: "The number of days that the patient was hospitalized or otherwise treated (ie number of visits made by a health care professional on an inpatient/outpatient basis).",
          drg_code: "A code used to describe the Diagnosis Related Group for this claim.",
          drg_description: "A Description of the Diagnosis Related Group Code.",
          emergency_room_category: "Defines if the claim/service is an emergency or non-emergency.",
          end_of_month: "Used to pull claims for a given month.",
          gpi_code: "The GPI Code value.",
          gpi_description: "The GPI Description.",
          hcpcs_cpt_code: "The HCPCS CPT Code value.",
          hcpcs_cpt_code_description: "The HCPCS CPT Code description.",
          major_diagnosis_code: "Code used to identify major diagnosis categories.",
          member_id_base: "Contains the value in positions 8 through 16 of the consistently formatted MBR_ID value.",
          member_key: "A assigned value to uniquely identify the member.",
          ndc_code: "The NDC Code value.",
          ndc_description: "The NDC Code description.",
          npi_number: "The NPI Number.",
          paid_amount: "Amount paid by Insurer to Provider.",
          paid_at: "The date a transaction enters the back-end financial system and dollars are considered paid.",
          place_of_service_category: "Defines the claim subcategory (MH, CD, Acute, Non-acute, CPT, HCPCS Level II).",
          primary_discharge_diagnosis_code: "An ICD Diagnosis Code identifying the primary diagnosed discharge medical condition.",
          primary_icd_procedure_code: "An industry defined code which identifies the primary medical service performed.",
          product: "Defines the product name used to categorize the services.",
          provider_name: "Identifying provider information.",
          provider_id: "An identification number for the provider or organization. An identifier is assigned to hospitals, doctors, extended care facilities, home health services, and pharmacies.",
          provider_organization_name: "The parent entity of the Provider.",
          provider_specialty: "The Provider Specialty description.",
          provider_specialty_code: "Code representing the Provider Specialty.",
          provider_specialty_type: "The Type of Provider Specialty description.",
          provider_specialty_type_code: "Code representing the Provider Specialty Type.",
          readmission: "Indicates if a member has been readmitted within 30 days of a previous visit. This excludes consecutive visits.",
          service_category: "Defines the service category (Maternity, Surgery, Radiology, Lab, E & M, other).",
          risk_score: "A risk score provided by the Insurer.",
          service_from: "The date services begin. This represents the Admit Date for certain types of claims, such as a hospital encounter.",
          service_to: "The date services end. This represents the Discharge Date for certain types of claims, such as a hospital encounter.",
          state_revenue: "Amount paid to Insurer by the State.",
          tax_id: "The Tax ID of the provider.",
          visit_count: "The count of visits associated with the claim.",
          total_revenue: "Total amount paid to Insurer for the claim."
        },
        custom_converter: {
          mapped_values: {
            default: "Mapped values can contain only one rule flagged as default."
          }
        },
        custom_playback_field: {
          name: "The field name that will be presented as a markdown value in outreach action scripts. Usually written in camel case. E.g. \"new field\" would be written as \"NewField\". The name cannot be changed while being used in scripts."
        },
        data_generation: {
          patient_admitted_percentage: "Percentage of patients that should be currently admitted.",
          patient_programs_mode: "Calls can be scheduled for the program or attempted with a random status. If create interactions is selected a successful call attempt will be created without triggering issues. If create issues is selected, a successful interaction with issues will be created.",
          patient_rounding_create_issues: "If unchecked, the generated answers for the interaction will not trigger issues.",
          patient_rounding_scripts: "Rounding interactions will be created for the selected scripts.",
          patient_rounding_author: "If no user is selected, your user will perform all the rounds.",
          patient_units: "An encounter will be created for each patient, and one of the selected units will be randomly picked as the encounter location.",
          patient_phones: "Useful for test calls, each patient will be given one of the specified numbers.<p><i>Currently, the call scheduler does not allow enrolling different patients with the same phone number; test patients will be given a fake phone if the amount of generated patients is greater than the amount of phones.",
          unit_transfer_percentage: "Percentage of test patients that will be transferred randomly to one of the selected units.</i></p>",
          issues_close_percentage: "Percentage of test patient issues to randomly close.",
          issues_attempt_percentage: "Percentage of open test patient issues to randomly attempt.",
          admitted_percentage: "Percentage of patients that should be currently admitted.",
          call_generator_mode: "Calls can be scheduled for the program or attempted with a random status. If create interactions is selected a successful call attempt will be created without triggering issues. If create issues is selected, a successful interaction with issues will be created.",
          create_rounding_issues: "If unchecked, the generated answers for the interaction will not trigger issues.",
          rounding_script_ids: "Rounding interactions will be created for the selected scripts.",
          rounding_author_id: "If no user is selected, your user will perform all the rounds.",
          unit_ids: "An encounter will be created for each patient, and one of the selected units will be randomly picked as the encounter location.",
          phones: "Useful for test calls, each patient will be given one of the specified numbers.<p><i>Currently, the call scheduler does not allow enrolling different patients with the same phone number; test patients will be given a fake phone if the amount of generated patients is greater than the amount of phones."
        },
        transfer_simulation: {
          transfer_percentage: "Percentage of test patients that will be transferred randomly to one of the selected units"
        },
        issue_simulation: {
          close_percentage: "Percentage of test patient issues to randomly close.",
          attempt_percentage: "Percentage of open test patient issues to randomly attempt."
        },
        data_exchange_export_job: {
          auto_archive: "When enabled, previously exported files are moved to the <i>exported_files/archive</i> folder every time the export is performed.",
          collapse_new_lines: "When enabled, if line breaks appear on the exported content, they will be replaced by spaces.",
          data_since: "Only data created after the selected date will be exported (optional).",
          encoding: "Use ONLY if the export should be encoded to a specific encoding type. E.g. WINDOWS-1252<br/> Useful for clients who report 'strange' glyphs visualization after loading the data into their system. UTF-8 is the default encoding when this value is not specified.",
          filename: "Prefix of the file created through SFTP <b>(without the extension)</b>. A timestamp is appended after the name.",
          frequency: "Determines - along with the recurrence mode - how often the job will run.",
          gpg_public_key: "Use ONLY if the export should be encrypted using a GPG public key.<br/> The care provider supplies their public GPG encryption key, which Evolve will use to encrypt the resulting export.",
          gpg_recipient_email: "Use ONLY if the export should be encrypted using a GPG public key.<br/> The care provider supplies the email address used to generate the public key.",
          lookback_days: "Amount of days in the past that the export should include (until the time in which the export is executed).",
          next_export_at: "Date in which the next export will be performed.",
          recipient_ids: "Users will receive an email with a link to download the export.<br/> The export file is replaced every time an export is performed.",
          recurrence_mode: "Determines the recurrence mode. To be used along with frequency.",
          skip_header: "When enabled, the header won't be included in the exported CSV file.",
          data_filter_field: "Defines what timestamp filter the export job uses to retrieve data related to the export period. Relevant only when the export uses data range filtering, such as with all 'recent' or 'loopback' exports as well as 'total' exports with a non-null data-since field.",
          extension: "Use ONLY if the export job file should be saved with a different file extension rather than the default one set by \"Export Format\" above, otherwise leave empty",
          type: "<i>Total Exports</i> include all the data, starting from an optional <i>Export Data Since</i>.<br/> <i>Recent Exports</i> only include the new data since the last export date (or <i>Export Data Since</i> the first time) up to the day before each export is performed.<br/> <i>Lookback Exports</i> include the data since (x) amount of days before the time of the export execution.",
          time_critical: "Enable only if it's crucial to get the job to run as close as possible to the scheduled time. When in doubt, leave unchecked.",
          lock_status: "This export job will automatically become inactive after a period of download inactivity. Check this box to keep the job permanently active."
        },
        data_exchange_night_time_info: {
          all_day: "No alerts will be sent on the days selected"
        },
        data_view: {
          allow_column_load_optimization: "Allow to load a fraction of the columns for associated exports and dashboards",
          always_display_total: "When enabled, the total amount of results will be displayed without having to click 'Show total'. Displaying the total can make the page <b>slower</b>, enable it only if it's vital for the users workflow, and never when <em>Show All Issues?</em> is enabled.",
          auto_refresh_enabled: "This setting will auto-refresh the open cases dashboard every X seconds, regardless of user activity. This provides users with enhanced visibility into newly created issues without forcing them to manually refresh the dashboard. This feature is currently in Beta and cannot be enabled without approval from the Product team.",
          combine_similar_questions: "Enable it to allow all selected questions with a similar name (including a language prefix), to be combined in a single column.",
          combine_similar_script_questions: "Enable it to allow all selected script questions with the same title to be combined in a single column, even if they are in different rounding scripts.",
          default: "Display this view as default for users without a set view",
          default_search: "Displays the default search set in the legacy version of this view. For VueJS views use the default search option in the search toolbar.",
          deprecated_lookback_days: "Number of days back to show Issues for when the 'show all issues' setting is enabled.",
          description: "Describe the purpose of this view, and how it's used in the care provider.",
          disable_mass_actions: "Disables mass actions, hiding the checkboxes in the rows. Only useful when no one uses mass actions in this view, and it has many columns so they would benefit from the extra space.",
          export_one_care_gram_per_recipient: "Generates one row per each of the email recipients in a single care gram",
          only_with_free_responses: "When selected, interactions without free-text and/or free-voice responses will be skipped from the results.",
          restrict_external_queries_threshold: "Allows to prevent search errors in certain scenarios. Ask a developer for help if you think it should be increased. Increasing it too much can degrade performance (for example, when higher than 3000).",
          show_all_issues: "When disabled, only open issues are displayed. When enabled, you may also configure the default search to filter by closed issues.",
          sort_by_discharge: "Sorts results by discharge date. For faster load times, disable this option."
        },
        encounter_criterium: {
          action: "Whether to add or remove Patient Tags or Rounding Flags when the criteria is met.",
          post_discharge_limit: "This field limits how many days after an encounter's discharge date the encounter criteria may trigger.",
          priority: "Encounter Criteria priority is on a scale of 1-10, with 10 being the highest priority. If an encounter criteria rule has a higher priority than others in this CP, it will trump the others and be the only one to trigger. If multiple encounter criteria rules are the same, highest priority, they will all trigger.",
          view_blueprints_condition: "Patients will not be re-enrolled into the workflow(s) if the encounter is updated and the above condition met again.",
          view_blueprint_ids: "Patient will be enrolled in these Workflows."
        },
        medication_criterium: {
          priority: "Medication Criteria priority is on a scale of 1-10, with 10 being the highest priority. If a medication criteria rule has a higher priority than others in this CP, it will trump the others and be the only one to trigger. If multiple medication criteria rules are the same, highest priority, they will all trigger."
        },
        escalation: {
          require_reason: "When selected, this will require a user to enter additional free text detail around the purpose of their escalation."
        },
        facility: {
          region: "Hierarchy used when reporting for all of our major systems, similar to Unit Group.",
          time_zone: "Time zone to be used when creating new units from imports."
        },
        login_page_content: {
          url: "The URL where the user will be redirected if clicking the content in the login page.",
          image: "Image must be 948px by 913px, displayed on the right section of the login page."
        },
        migration: {
          throttle: "Amount of seconds to wait between each migration loop, to artificially slow down the rate of operations. You must <b>stop and restart</b> the migration for this change to take place."
        },
        orchid_settings: {
          rounding_script: "Select a rounding script to use in the mobile app. If a Rounding Script is selected, it will be used instead of the Outreach Program.",
          staff_rounding_script: "Select a rounding script to use for Staff Rounding in the mobile app. If a Rounding Script is selected, it will be used instead of the Outreach Program.",
          orchid_combine_room_and_bed: "This option, when set to true, will combine a room value and bed value through the serializer in the room field within the mobile and web rounding application.",
          encounter_api_fields: "Those fields will be displayed after Patient API fields in this order in mobile app",
          patient_api_fields: "Those fields will be displayed before Encounter API fields in this order in mobile app",
          outbound_call_outreach_action_id: "Select the outreach action that will play when a user launches an outbound call to a patient through Orchid.",
          phi_level: "Leave empty to use the care provider's default configuration.",
          ios_landing_page: "Defaults to Patient. If an option is not displayed, check if the user has access to rounding scripts of that type."
        },
        patient: {
          opt_out_channels: "These channels will not be updated via data feeds."
        },
        patient_tag: {
          name: "The name must be unique for this care provider.",
          color: "Leave empty to use the default tag color.",
          description: "Provide a short explanation about how the tag is used.",
          for_tagging_rules: "Automatic tags (used for instance to mark a patient as 'frequently readmitted' or 'high utilizer') will be automatically applied when patient meets criteria. These tags will not have the ability to be manually assigned by users or applied in an encounter criteria rule.",
          warn_when_tagged: "A warning will be displayed next to the patient name in the open cases dashboard if this option is selected."
        },
        rounding_flag: {
          description: "Provide a short explanation about how the flag is used."
        },
        user: {
          alert_user: "Non-SSO user accounts are disabled after a period of inactivity specified by the care provider. Check this option if you want to prevent certain accounts, such as those used to send notification emails, from ever being disabled.",
          test_user: "Whether this user is a test account. Provides a way to conveniently delete them in the Demo Data page after a demo or training."
        },
        unit: {
          facility: "Please do not edit facility names manually, because there will be issues with reporting. If it needs to be changed, coordinate with the client to update the facility field of the HL7 message or SFTP file that is imported.",
          building_code: "Unique code used in the ServiceNow integration",
          roundable: "Only encounters from \"Roundable\" units will be displayed in the Admitted Patients lists (web and mobile) for rounding.",
          phonetic_spelling: "Explicitly defines sounds of the unit's name. For example \"C R 1 Hun dread\".",
          file_name_pattern: "Indicate the file name pattern for files that will match this import association. You must indicate the static portion of the file name the association will be used for. Ex. If the file name is in the format of [clientname_inpatient_discharges_startYYYYMMDD_endYYYYMMDD] then you should put [clientname_inpatient_discharges], dropping the portion of the name that will change with each file.",
          roundable_types: "(Mobile) Used to determine units that should be available for filtering in unit rounding and units for patient rounding."
        },
        import_association: {
          name: "Specify a name if you wish to <b>save</b> the association, allowing files with the same header to be automatically mapped. If saving an association for files without headers, the association will match on the ‘File Name’ provided below.",
          patient_matching: "If a patient matching algorithm is set for the import, Evolve will check for existing matching patients using this method before proceeding to the care provider primary and secondary patient matching algorithms. This should only be used if a specific import does not contain all patient identifiers selected for care provider patient matching.",
          file_name_pattern: "Indicate the file name pattern for files that will match this import association. You must indicate the static portion of the file name the association will be used for. Ex. If the file name is in the format of [clientname_inpatient_discharges_startYYYYMMDD_endYYYYMMDD] then you should put [clientname_inpatient_discharges], dropping the portion of the name that will change with each file."
        },
        association: {
          patient_matching: "If a patient matching algorithm is set for the import, Evolve will check for existing matching patients using this method before proceeding to the care provider primary and secondary patient matching algorithms. This should only be used if a specific import does not contain all patient identifiers selected for care provider patient matching.",
          unused_alert_threshold: "The amount of days that must pass of this association not being used before an alert is sent."
        },
        issue_alert: {
          message: "For 10-DLC compliance, an SMS opt-out message will be automatically added at the bottom of this message.",
          priority: "Alert priority is on a scale of 1-5, with 5 being the highest priority. If an alert has a higher priority than other alerts in the same program, it will trump the other alerts and be the only one to trigger. If multiple alerts are the same, highest priority, they will all trigger."
        },
        issue_panel: {
          priority: "Issue priority is on a scale of 1-10, with 10 being the highest priority. If an issue has a higher priority than other issues in the same program, it will trump the other issues and be the only one to trigger. If multiple issues are the same, highest priority, they will all trigger.",
          use_intervention_timer: "The intervention timer will appear in open issues.",
          show_triggering_response: "When enabled, open issues only display the answer choice(s) that triggered the issue, instead of every selected answer on the question.",
          timeout: "When specified, open issues are automatically closed after X hours of being open."
        },
        issue_subpanel: {
          improvement_area: "Improvement Area helps track issues identified by staff. For example, a patient's concern with noise or clutter.",
          call_status: "Call Status tracks issues with an Outreach call, such as being unable to leave a voicemail or the patient pressed the wrong button.",
          clinical_feedback: "Clinical Feedback tracks information received from the patient, such as difficulty in obtaining medication or shortness of breath.",
          follow_up_action: "Follow Up Action tracks actions taken by staff to help resolve patient issues, such as discussing concerns or referring a patient to a specialist.",
          show_title: "If you choose to not show the Issue Subpanel title, an individual field's title will appear as a bolded title."
        },
        care_gram_email_template: {
          care_grams_email_image: {
            image: "Recommended image dimensions are 580 x 218 pixels or similar image proportions"
          },
          name: "Name the template so that it is easy to identify",
          message: "Set message text for Care Gram email. Supported variables: [AuthorName], [AnswerText], [Recipients], [RoomNumber], [PatientInitials], [StaffMemberName], and [CareProviderName]. Confirm that including patient initials in a notification is in compliance with the organization's security policies before adding [PatientInitials] to the email template message."
        },
        floorplans_settings: {
          automatic_pagination: "Determines whether encounters feed will automatically paginate through encounters on the feed, or whether it will show all feed encounters on a single page.",
          minimalist_view: "A simpler design for the live floorplans page that shows less content than the default floorplans view.",
          page_size: "Maximum amount of encounters that will be shown on a floorplans feed view per page. If automatic pagination is turned off and this number is set, the page will only display this number of encounters.",
          script_id: "This rounding script will be used to get the last rounded date when sorting encounters on the live feed.",
          show_patient_initials: "Show patient initials on the encounters feed.",
          show_rounding_assignees: "Show rounding assignees on the encounters feed."
        },
        hl7_settings: {
          hl7_import_interval: "Tip: There are 1,440 minutes in one day.",
          hl7_alert_contacts: "Emails of IT contacts in the care provider that should be notified if no HL7 messages have been received in the specified interval.",
          hl7_live: "By marking this CP as Live, no messages generated from the client's test engine will be imported.",
          hl7_preferred_channel_by_priority: "Setting for clients using a repeating sequence that indicates phone number priority in the PID-13 segment and would like to assign mobile phones to \"sms only\".",
          hl7_purge_interval: "Set this value to remove old HL7 imports from this CP after X days. Default is 30. This option works only with HL7 configured Care Providers that have the 'hl7' label."
        },
        hl7_mapping_association: {
          mappings: {
            blanks_as_null: "Treats omitted fields as null values. It is STRONGLY recommended to leave this setting as false as turning it on is actually violating the HL7 standard. HL7 clearly separates blanks and field omissions from null values, which are represented with the \"\" string (two consecutive double quotation marks)."
          }
        },
        appointment_cancellation: {
          type: "Triggered after an appointment is cancelled as part of an outreach program. Default configuration uses SIU^S15 HL7 message."
        },
        appointment_confirmation: {
          type: "Triggered after an appointment is confirmed as part of an outreach program. Default configuration uses SIU^S14 HL7 message."
        },
        patient_comment_change: {
          type: "Triggered when a patient comment is created / modified. Default configuration uses ORU^R03 HL7 message."
        },
        interaction_export: {
          type: "Triggered after an outreach interaction finishes, allows exporting interaction and patient data. Default configuration uses an ORU^R01 message"
        },
        issue_panel_closed: {
          type: "Triggered when an issue panel is closed. Default configuration uses MDM^T02 HL7 message."
        },
        issue_panel_reopened: {
          type: "Triggered when an issue panel is reopened. Default configuration uses MDM^T11 HL7 message."
        },
        care_provider: {
          additional_roundable_information_fields: "Additional information displayed in main roundable view for each patient. Limit 2 selections. First selection will serve as a sorting field for CipherRounds remote search only if it is an encounter field.",
          additional_staff_information_fields: "Additional information displayed in main roundable view for each staff member. Limit 2 selections.",
          additional_location_information_fields: "Additional information displayed in main roundable view for each location. Limit 2 selections.",
          admitted_import_interval: "The alert goes off after the specified interval in minutes ellapses without imports (excluding idle hours).\nTip: There are 1,440 minutes in one day.",
          allowed_countries: "Select countries for which phone numbers will be acceptable. US is added always to the list.",
          allow_identifier_matching: "When a patient has not been found by primary, secondary and tertiary patient matching algorithm, then the patient identifier matching is used. * Works same as `Default` option for Secondary Patient Matching",
          allow_impersonate_for_external_users: "By default, user impersonate permission is disabled for all users who are not cipher members. By enabling this option we allow external users to use the `See As` functionality.",
          allow_only_one_active_session: "Enabling this feature will end any user's session in Evolve when the same user logs in from another location / browser.",
          auto_logout_hours: "Number of hours before an active user will be automatically logged out of the app",
          care_grams_email_image: {
            image: "This image will appear as the logo in all caregrams emails. The default image is the CipherHealth logo. If the uploaded image looks out of proportion below, try cropping it. The ideal image is 248 pixels wide and 82 pixels tall."
          },
          care_grams_email_image_file: "This image will appear as the logo in all caregrams emails. The default image is the CipherHealth logo. If the uploaded image looks out of proportion below, try cropping it. The ideal image is 248 pixels wide and 82 pixels tall.",
          care_notes_access: "Controls whether a user can see all care notes, only notes created within the current care provider, or only notes the user authored.",
          cc_author_on_round_summary_emails: "If this setting is on, the rounder will receive a copy of the Round Summary. Note that this would allow the recipient of the Round Summary to reply to the rounder.",
          connect_to_epic_sandbox: "Enabling the setting will connect to a non-production environment in Epic; Disabling the setting will connect to a production environment in Epic.",
          consider_opt_out_as_reached: "If set to true this setting will consider Opt Out status as reached and will not trigger unreached issue panel.",
          disable_caregram_emails: "When this setting is turned on, we will no longer send care gram emails for this care provider. This usually happens when we integrate this care provider with a recognition vendor like OC Tanner.",
          display_full_staff_rounding_timestamps: "Use MM/DD/YYYY HH:MM format for staff rounding timestamps",
          due_soon_includes_overdue: "Include overdue tasks in Due Soon filter?",
          echo_settings: {
            additional_question_issue_panel_id: "If selected, an issue will be created when a patient submits a question from the embeddable Care Recordings page.",
            additional_question_issue_alert_id: "If selected, an alert will be sent when a patient submits a question from the embeddable Care Recordings page.",
            embeddable_echo_disclaimer_message: "Disclaimer message to be shown in the footer of the page. Remember to update it with the actual expiration used in the care provider."
          },
          enable_alert_management: "Enable the new alert management feature in the user management page for this Care Provider",
          enable_location_tags: "Enable the new location tags feature in the user locations search for this Care Provider",
          enable_caregram_recipient_autocomplete: "Enables the autocomplete list for care gram recipients in rounding. This setting should be disabled if CareGram questions are slow to load.",
          enable_email_template: "Use Email template instead of plain html when sending Care Provider related emails",
          enable_orchid_badges: "Deprecated. Enables ability to count user rounds, and reward digital badges in mobile app. This will be turned on for all care providers.",
          enable_product_usage_form: "Shows an in-app notification form in Evolve when users log into their account asking for job function, role and job title.",
          enable_staff_on_duty_status: "If the care provider updates the On Duty? status of its staff members through an import, this feature allows users to filter staff rounds based on the on_duty field.",
          enable_staff_hierarchy: "If the user has a corresponding staff member record in evolve, it will enable the usage of the user's hierarchy within the organization for data filtering purposes. This setting overrides the permission \"View Staff Interactions Created By Anyone\".",
          enable_staff_rewards: "Show the staff rewards section in the staff member history, and allow sending rewards from the staff member page.",
          enable_staff_pronouns: "Select to show the staff member's pronouns in rounding workflows.",
          enable_patient_preferred_name: "Select to show the patient's preferred name in rounding workflows.",
          enable_patient_preferred_pronouns: "Select to show the patient's pronouns in rounding workflows.",
          encounter_api_fields: "Additional encounter fields to display",
          encounter_id_fields: "The selected fields will be used to craft an artificial `Encounter ID` - consisting in the concatenation of those fields - when no `Encounter ID` is supplied.",
          expire_echo_access: "This field will limit a patient's access, either via the patient portal UI or any type of Outreach Action with Care Recordings enabled. The 'days' variable refers to the days after the discharge date on the encounter associated with the care recording message.",
          failed_sign_in_limit: "Setting this value will determine the number of times a user can incorrectly attempt to sign into their Evolve account before we automatically send them a password reset email.",
          fallback_patient_matching: "When a patient has not been found by the primary patient matching algorithm, then the secondary patient matching is used. The secondary “default matching algorithm” is patient first_name, last_name, dob and phone. * Only in cases where Primary Matching and Secondary Matching are both set to 'default matching algorithm' will you be able to have both be set to the same values. Otherwise, please always ensure these are different.",
          file_alert_contacts: "Emails of IT contacts in the care provider that should be notified if a file has not been received in the specified interval.",
          generate_rounding_summary_ai: "Show the AI-generated summary of the past round. This feature flag takes about 24 hours from enabling this button to receiving insights.",
          generate_staff_rounding_summary_ai: "Show the AI-generated summary of the past staff member round. This feature flag takes about 24 hours from enabling this button to receiving insights.",
          hl7_alert_contacts: "Emails of IT contacts in the care provider that should be notified if no HL7 messages have been received in the specified interval.",
          hl7_import_interval: "Tip: There are 1,440 minutes in one day.",
          hl7_live: "By marking this CP as Live, no messages generated from the client's test engine will be imported.",
          hl7_purge_interval: "Set this value to remove old HL7 imports from this CP after X days. Default is 30. This option works only with HL7 configured Care Providers that have the 'hl7' label.",
          hl7_outbound_use_trailing_return: "When checked, it adds a trailing carriage return to the last segment. While the HL7 standard states that every segment should end with a carriage return - even the last one - some systems might not support it correctly.",
          ignore_script_access: "This setting allows users to see all historical patient interactions regardless of script access",
          import_interval: "The alert goes off after the specified interval in minutes ellapses without imports (excluding idle hours).\nTip: There are 1,440 minutes in one day.",
          inactive_user_deactivation_days: "After this many days, if a user has not signed in, their account will be deactivated.",
          integration_token_expiration: "This setting defines the time-to-live value in minutes of the session we create for a patient using a third-party site and trying to access its care recording audio instructions in evolve.",
          interaction_history_endpoint_types: "Defines Interaction types returned by the Interactions History Endpoints. If empty all Interactions are returned.",
          interactions_endpoint_limit: "Sets the amount of interaction results that should be returned when accessing the \"My Rounds\" or \"Recent Interactions\" screens in mobile Orchid. Choose a number between 1 and 200.",
          invitations_email_domain: "This option determines what email addresses domains can be allowed for invitations.",
          log_out_interval_activated: "Number of minutes before an inactive user will be automatically logged out of the app",
          logout_on_quit: "Logs out a user after the app is closed/killed. If the setting is not enabled, a user would automatically log in, when the app is re-opened.",
          notification_upon_login: "This text will appear on a user's landing page after each login.",
          notify_negative_answer: "Presents notification that previous interaction recorded a negative answer.",
          only_count_open_rounding_issues_for_patient: "When enabled this will only display open issue notification if open issues are of type \"rounding\"",
          optimize_imports_enabled: "When checked, staff and admitted patient sftp file imports are pre-processed, so that only the rows that are different from the previous import are imported.",
          orchid_combine_room_and_bed: "If checked this will display Bed A in Room 403 as \"403-A\". If unchecked, this will display \"403\"",
          orchid_sso_federated_logout: "If this option is enabled, SSO users who log out of CipherRounds will also be logged out of their identity provider.",
          outbound_call_outreach_action_id: "Used for sales demos to show how a care recording message would appear within the chosen Outreach Action",
          password_change_interval: "This setting forces a user to reset their password after X days of having it live.",
          password_reset_link_expiration_interval: null,
          patient_api_fields: "Additional patient fields to display",
          patient_demographics_encounter_sort_order: "This field specifies the encounter sort order applied to the Patient Demographics section of the Blueprint Patient Show page. For example, \"Descending Arrival Date, Descending Discharge Date\" will sort encounters primarily by arrival date (newest to oldest), and then (for any ties) secondarily by discharge date (newest to oldest).",
          patient_information_encounter_sort_order: "This field specifies the encounter sort order applied to the Patient Information section of the Evolve Patient Show page. For example, \"Descending Arrival Date, Descending Discharge Date\" will sort encounters primarily by arrival date (newest to oldest), and then (for any ties) secondarily by discharge date (newest to oldest).",
          permanent_caregram_recipient_emails: "List of emails that will be cc'd on every care gram email that is sent",
          phi_level: "Controls formatting of patient name and room number",
          primary_patient_matching: "Primary Patient Matching is the first method used to find and match existing patients. It is recommended to use fields which can clearly identify a patient. The primary “default matching algorithm” is encounter_MRN to “create” a patient and matching only on encounter_MRN for existing patient updates (allowing for phone/name changes). * In this scenario, if the existing patient is not matched on encounter_MRN, then a new patient is simply created with the first_name, last_name, dob, phone algorithm as the secondary patient matching.",
          public_key: "Paste OpenSSH or RFC4716 (SSH2) public keys. RSA and DSA supported.",
          prompt_users_for_feedback: "By enabling this setting, users will be prompted to leave feedback in the Notifications section of the Evolve header once every X days",
          referral_sources: "Used in View patient enrollment.",
          required_encounter_form_fields: "If Encounter Form Fields are not set, Encounter ID is required. When Encounter Form Fields are defined, Encounter ID will not be displayed.",
          required_patient_form_fields: "First Name and Last Name are permanently required.",
          return_full_interactions_history: "Allows the care provider to determine whether a user can view full interaction history for a patient, or if the interactions shown will be restricted to only those matching the user's criteria",
          room_and_bed_show_options: "Controls how and if the room and bed fields are displayed.",
          secondary_referral_sources: "Used in View patient enrollment.",
          send_mrn: "Sends MRN for to mobile app to allow for barcode scanning to find patient records.",
          send_sso_invite_email: "If this option is enabled, a notification email will be sent to a user when SSO is enabled for their account.",
          sftp_password: "Required minimum 8 characters including digit, special character, capital and lowercase letter.",
          sftp_source_ip_address: "Please provide the IP address from which you are sending your file.",
          sftp_username: "Use lowercase letters (a-z), numbers (0-9), '_' and '-'. Maximum length is 24 characters.",
          show_add_patient: "Allows users to create new patient records directly from the rounding view.",
          show_add_staff_member: "Allows users to create new staff member records directly from the rounding view.",
          show_caregram_history: "Show historical care grams in the staff member history section",
          show_patient_page_users_online: "This option will allow a user to see which other users are visiting the same patient / staff page.",
          enable_staff_outreach: "Enables showing Staff Outreach fields in the New Patient form.",
          show_unit_visits: "Only for iOrchid v5.3.0 and above",
          staff_member_api_fields: "Additional staff member fields to display. Only for Orchid v5.3.0 and above.",
          location_api_fields: "Additional location fields to display.",
          location_rounding_page_count: "This setting allows a CP to set how many locations display on a page. This applies to the Engage tab. If left blank, the default locations per page is 10.",
          task_categories: "Used for workflow tasks, blueprint tasks, and as needed tasks.",
          thresholds_check_time: "Thresholds for Additive Key Metrics are checked every day on the selected hour.",
          threshold_for_rounding_post_discharge: "Allows rounding on recently discharged patients for a set number of hours post-discharge",
          tertiary_patient_matching: "When a patient has not been found by the primary and secondary patient matching algorithm, then the tertiary patient matching is used. * The tertiary \"default matching algorithm\" does nothing by default.",
          touch_login: "Allows users to login using Touch/Face ID",
          two_factor_authentication: "After enabling this option, you'll be prompted to enter a 2FA code. You should receive an email with the code.",
          biometric_login_expiration_days: "Number of days before a user's Biometric token expires.",
          translation: "Specify which translation dictionary should be used for this care provider to provide custom terminology.",
          use_referral_source: "Allow to select a referral source when enrolling a patient in View.",
          use_react_pages: "When enabled, ported pages open in React for CipherHealth early-access users on this provider. Customer users always stay on the current Vue pages.",
          use_slick_pages: "When enabled, all slick pages will be enabled by default for all users in the care provider.",
          use_unit_facility_in_name: "This should be used when the care provider has multiple units with the same name in different facliities. Units will show up as options with the facility name in parenthesis next to the unit name or short name.",
          users_activity_settings: {
            enabled: "This feature enables daily users activity log export. This log will contail entries with all implemented log events"
          },
          user_timeout: "This will log a user out after inactivity of the set number of minutes. The range of options are 5 to 60 minutes."
        },
        sso_connection: {
          name: "This should match one of the Connection Names in Auth0",
          domains: "Collection of domains that will be associated with this SSO connection. Will only be used for connections of type 'Azure'"
        },
        department: {
          group: "Useful for Analytics and Criteria as a way to group departments, similar to unit groups.",
          roundable: "Only Staff Members from \"Roundable\" department will be displayed in the Staff Rounding lists (web and mobile) for rounding.",
          phonetic_spelling: "Explicitly defines sounds of the department's name. For example \"Hoo man Ree sores es\"."
        },
        survey_device: {
          login_id: "Set a unique login id for the device.",
          rounding_script_ids: "Select the surveys that the device should have access to. You can change the order the surveys are presented to the user by dragging and dropping the selected surveys. If no survey is selected the device will fall back to using all surveys that belongs to the same location as this device.",
          qr_device: "Set this if the device will be intended to be logged in with a QR code."
        },
        map_value: {
          default: "Mapped values can contain only one rule flagged as default."
        },
        outreach_action: {
          allow_reenrollment: "When active, it allows enrolling into the outreach action despite having a previous interaction.",
          gemini_tts_voice_talent: "When set, missing audio files for this outreach action will be generated using the selected Gemini TTS voice talent when you save a question.",
          channel: "List of channels that are supported for this outreach action. Be aware that the order matters (order in which the channels are added is the order that will be used when trying to reach the patient).",
          expiration_shift: "For inbound-enabled Outreach Actions, this setting determines how many days after the last unsuccessful attempt the patient may call inbound to finish the interaction.",
          unlimited_inbound_expiration: "This setting determines how many days after the first attempt the patient may call inbound. There is no limit on the amount of times a patient can call inbound. Each inbound call will create a new attempt and interaction unless there is an open attempt/interaction that can be used. In order to input a value in this setting, the “Inbound Expiration (days)” value must be blank.",
          manual_issue_panel_id: "On program enrollment, an issue will be triggered according to the selected Target Outreach Plus. The issue panel should be configured to allow performing an interaction for this outreach action",
          max_early_hangups: "This setting will discontinue call attempts after X consecutive hangups by the patient. Leave it blank for an unlimited number of hangups.",
          max_early_hangups_abort_mode: "By selecting GLOBAL, we will stop retries completely after reaching the maximum allowed number of hangups. By selecting DAY, we will stop calling the patient that day and move to the next day (if applies).",
          repeat_interval: "Set in days. The Outreach Action will send every given number of days until a post-admit discharge date has been reached, when the patient expires, or when the Repeat Count (configured below) is reached.",
          repeat_count: "When set, we will repeat the OA that many times, unless a discharge date is reached before that count of repetitions.",
          voice_mail_allowance: "This setting allows to choose on which calls this outreach action will leave a voicemail if the patient is not reached."
        },
        outreach_program: {
          multiple_encounter_multiple_enrollment: "When this setting is checked it allows encounters belonging to 1 patient to be enrolled in this program. If you want it to work across other programs it needs to be turned on in those programs too.",
          allow_only_one_enrollment_per_program: "When the setting is enabled, only one encounter per patient can be enrolled at any time.",
          allowable_call_days: "To update outreach days for a facility-specific outreach time use the custom outreach hours section. To update an outreach time for non-facility specific outreach use the custom outreach hours and do not specify a facility.",
          non_allowable_days_fallback: "When enabled and a pivot date is too close for engagement to occur on an allowable day, patients will be engaged on the current date. When disabled, engagement will never occur on non-allowable days.",
          disable_engagement_on_non_allowable_days: "When disabled and a pivot date is too close for engagement to occur on an allowable day, patients will be engaged on the current date. When enabled, engagement will never occur on non-allowable days.",
          extended_call_hours_support: "⚠️ Enabling this setting allows calls and SMS to be sent to patients <b><ins>after hours</ins></b>. This is particularly useful for locations operating 24/7, such as emergency departments, where communication may be necessary at any time. <b><ins>Use with caution</ins></b>, as sending calls and messages during late hours might disturb patients. Ensure that after-hours communication is appropriate for your specific use case before enabling this option.",
          completed_message: "Plays when patient has completed an Outreach Call OA or meets the inbound call expiration limit set on the OA.",
          custom_call_hours_range: "Helps to easily add a range of custom outreach hours, for all allowed days, and without a specific facility or department group.",
          do_not_play_outreach_questions: "When enabled, does not play Outreach Action Questions after Inbound message",
          use_department_phone: "When clicking this option, the department's phone number from which the patient was enrolled will be displayed as incoming phone number for outbound calls and the outreach program phone number will be use for SMS outreach. If no department is set on the encounter or the department has no phone, then the outreach program phone number will be used. If that's not available, then the outreach program phone.",
          use_department_call_center: "When clicking this option, the phone number from department's call center from which the patient was enrolled will be used as the transfer phone number. If no department is set on the encounter or the department has no call center, then the live transfer number configured for the outreach program will be used.",
          use_department_transfer_phone: "When clicking this option, the department's phone number from which the patient was enrolled will be used as the transfer phone number. If no department is set on the encounter or the department has no phone, then the live transfer number configured for the outreach program will be used.",
          enforce_first_medical: "Enabling this feature requires also setting a question within your OA as the 'First Medical' question. This feature will then not consider the interaction successful until the patient has responded to at least the First Medical question in the script.",
          enrollment_alerts_on_first_hour: "If no patients are enrolled at the time of the first call hour of the day, an alert will be sent to the support email on this care provider.",
          enrollment_count_limits_mode: "Define how the enrollment count limits are evaluated when defined. Select global to limit the number of enrollments allowed at any moment and per-day to limit the enrollments allowed in each day.",
          enrollment_timeframe: "For post-discharge Outreach type program, this field limits how many days after the encounter's discharge date the OP enrollment may occur. For pre-admit Outreach type program, this field limits how many days before the encounter's arrival date the OP enrollment may occur. For post-admit Outreach type program, this field limits how many days after the encounter's arrival date the OP enrollment may occur. For call-on-date type program, the field limits how many days after the encounter's call on date the OP enrollment may occur.",
          expected_enrollment_days: "If no patients are enrolled into this program on one of the days selected above, an alert will be sent to the support email on this care provider.",
          forbidden_days: "The system will not place Outreach calls on the selected dates.",
          holidays: "By default, our system will not place Outreach calls on these holidays, but instead place the calls for that day on the day after. If you wish to have this OP call on any of these holidays, simply record that here.",
          inactive_program_message: "Plays when anyone calls inbound to a program that has been deactivated.",
          inbound_allow_test_call: "If clicked, default outreach action field will be activated.",
          inbound_mismatch_message: "Plays when anyone calls inbound from a phone number that is not related to an OA.",
          live_transfers_limit: "This limit will only apply if the program has a live transfer question.",
          phone: "Default Phone Numbers are used as the primary phone number for the Outreach Program. This number is also used as a backup in the event an interaction/recipient does not match the location criteria tied to the specific phone numbers below.",
          priority: "Priority can be used across OPs within a given Care Provider, if patients may meet activation criteria for more than one OP. The OP with the highest priority of the OPs a patient meets criteria for will be the one the patient becomes activated for. Priority scale is 1-10, 1 being the lowest and 10 being the highest.",
          remove_outbound_on_successful_inbound: "This option, when checked, will remove patients from outbound 'audio instruction' calls if they call inbound and have a successful care recording play. This option will not remove outbound outreach actions.",
          prompt_reach_delay_seconds: "By default, prompt reach programs launch at the same time an enrollment is made. This setting allows to delay the launch for a few seconds. Useful for medication affordabilty prompt reach programs where we have to wait for all medications to be created before we actually send the message.",
          schedule_care_recording: "Schedule outbound calls for audio instruction outreach actions.",
          short_name: "The short name will be displayed within the reporting platform, so make the name distinguishable across other Care Provider program names.",
          sms_alert_message: "Enabling the SMS Alert will trigger the SMS Alert Message set here to a patient after two unsuccessful call attempts.",
          sms_completed: "Sent when patient has completed an SMS OA or meets any of the SMS expiration limits set on the OA.",
          sms_reminder_message: "By setting this field, we will initiate a reminder SMS to the same patient phone number after 24 hours of the first unanswered SMS.",
          enrollment_alert_shift: "If no patients are enrolled into this program within the max allowable interval set above, an alert will be sent to the support email on this care provider. Best practice: for low volume programs that may not enroll each day, please set this alert instead of the 'Day of Week' alert for no enrollments. Tip: This is set to days, so consider 2 days for programs that may not enroll each day. No value or a value of zero means do not notify.",
          voice_phone: "This phone field can be used to send outbound voice calls when you are using a Twilio number for SMS outreach but want to use a non Twilio number for phone outreach. This way phone calls will use the number indicated here and SMS messages will use the Twilio number indicated in the 'Phone' field above.",
          voice_talent: "For an Outreach program with recordings by a voice talent, please enter the talent's name here.",
          webform_completed: "Displayed when patient has completed an OA or meets any of the expiration limits set on the OA."
        },
        pulse_email_template: {
          name: "Name the template so that it is easy to identify",
          message: "Set message text for Pulse email. Supported variables: [PulseName], [PulseURL], [PulseEndDate] and [CareProviderName]"
        },
        readmission_import: {
          csv: "The csv file should have no header, column 1 should be the care provider's encounter id and column 2 should be the days until readmitted",
          matching_encounters: "Encounter IDs in the .csv import file that match an encounter ID in Evolve will be marked as readmitted. If some encounter IDs in your file could not be matched, please review the format of the Encounter IDs included in your import file",
          criteria_encounters: "All encounters that fit the specified criteria will be updated. Encounter IDs in the .csv import file that are matched will be marked as readmitted and the remaining encounters will be marked as not readmitted"
        },
        related_settings: {
          thresholds_check_time: "Thresholds for Additive Key Metrics are checked every day on the selected hour.",
          use_referral_source: "Allow to select a referral source when enrolling a patient in View.",
          task_categories: "Used for workflow tasks, blueprint tasks, and as needed tasks.",
          referral_sources: "Used in View patient enrollment.",
          secondary_referral_sources: "Used in View patient enrollment."
        },
        report_package: {
          hour: "Time (EST) at which the report package will be sent, needs to be full hour (e.g. 4:00 PM). Not related to the Care Provider's timezone, always EST.",
          recipient_emails_list: "Recipients checked/unchecked will be added/removed to all report packages respectively. Leave the checkbox indeterminate to avoid making any changes to that email address",
          password: "You can optionally protect the report files attached with a password",
          merge_pdfs: "Select this option if you want all the report PDFs merged into a single one",
          start_date: "The date the package should start to send out. Use this field to schedule packages for the future."
        },
        role: {
          after_sign_in_url: "URL where the user is redirected after sign in. Each user can only have one provider role that defines it, so use this setting sparingly, as it could limit which roles can be combined.",
          care_form_groups: "Groups of care forms the user should be able to access.",
          data_view_ids: "Views that the user should be able to access.",
          description: "Describe the purpose of this role, and how it's used in the care provider.",
          issue_panel_ids: "When selected the user will only be able to see issues for the selected panels.",
          managed_by_imports: "Only roles managed by imports can be assigned or removed through user imports.",
          rounding_dashboard_ids: "Dashboards the user should be able to use from CipherRounds.",
          insights_dashboard_ids: "Insights dashboards the user should be able to access.",
          permissions: "Provide access to different actions and areas of the application.",
          rounding_flag_ids: "Rounding flags the user should be able to see and use for rounding.",
          rounding_script_ids: "Rounding scripts the user should be able to use for rounding.",
          slick_pages: "Whether the user should be able to see the new (Vue) version of the selected pages. NOTE: The permissions required to access the page should be granted separately.",
          two_factor_authentication: "Require Two Factor Authentication with code sent to the users email on sign in to Evolve.",
          type: "Use <b>Admin</b> if the role can only be granted by admin users.\nUse <b>Regular</b> if the role may be granted by non-admin user managers, such as external users.\n<b>NOTE:</b> Roles that grant internal permissions can only be <b>Admin</b>.",
          workflow_template_groups: "Groups of workflow templates the user should be able to access."
        },
        survey_settings: {
          email_subject_text: "Set subject text for Send Survey via Email messages. Supported variables: [CareProviderName]",
          email_message_text: "Set message text for Send Survey via Email messages. Supported variables: [CareProviderName] and [SurveyURL]",
          sms_message_text: "Set message text for Send Survey via SMS messages. Supported variables: [CareProviderName] and [SurveyURL]",
          notification_resent_delay: "Delay (in hours) before a new notification is re-sent via SMS or Email if the survey is still unanswered. 0 means the survey will not be re-sent"
        },
        staff_member: {
          healthcare_role: "Defines the role of the staff member that can be configured for Staff Picture question type.",
          show_in_kiosk: "Check this box if you'd like the the staff member to appear in the Kiosk Staff question for Devices that match the staff member's Location.",
          survey_location_ids: "Defines Survey Locations this staff member will be available for. If empty staff member will be available for all Locations."
        },
        view_blueprint: {
          link_blueprint_id: "When selected, enrolling patients in View will also enroll them in Link."
        },
        view_enrollment: {
          blueprints: "{{patient}} will be enrolled in:",
          configuration: "Using the following configuration:",
          care_team: "The care team is comprised of:",
          skill_sets: "And will be performing the following roles:",
          enrollment_date: "The enrollment date-time for all workflows will be set to:"
        },
        visit_provider: {
          phonetic_spelling: "Explicitly defines sounds of the visit provider's name. For example \"Doc tor Zhee Va Go\"."
        },
        whitelist_ip_address: {
          temporary_ip_address: "Selecting this option will remove the IP address from the database at the end of the day"
        },
        whitelist_reporting_email_domains: {
          domain: "Email Domain to be whitelisted for Report Emails and Alerts from Looker"
        }
      },
      placeholders: {
        care_provider: {
          import_interval: "Best practice: 1500",
          admitted_import_interval: "Best practice: 90",
          hl7_import_interval: "Best practice: 90"
        },
        data_exchange_readmission_import: {
          facilities: "Select facilities…",
          outreach_program_ids: "Select outreach programs…"
        },
        data_generation: {
          patients_amount: "Enter number of patients to create…",
          unit_ids: "Select units where the patients will be located in…",
          phones: "Enter phone numbers that will be used for the generated patients…",
          outreach_program_ids: "Select programs for enrollment…",
          call_generator_mode: "Select generation mode…",
          rounding_script_ids: "Select scripts to create interactions…",
          rounding_author_id: "Select the user that will round on the patients…"
        },
        transfer_simulation: {
          unit_ids: "Select units the patients should be transferred to…",
          transfer_percentage: "Select percentage of test patients that will be transfered to selected units…"
        },
        issue_simulation: {
          close_percentage: "Select percentage of issues to randomly close…",
          attempt_percentage: "Select percentage of issues to randomly attempt…"
        },
        floorplan: {
          name: "Choose a name for your floor plan…",
          unit_id: "And select a unit…"
        },
        import_rule: {
          type: "Select import rule type…",
          import_association_id: "Select association…"
        },
        issue_alert: {
          recipient_ids: "john@example.com",
          invited_recipient_ids: "jane@example.com",
          recipients: "Select recipients…",
          invited_recipients: "Select invited recipients…"
        },
        insights_dashboard: {
          dashboard_id: "Enter the ID of the Looker dashboard",
          name: "Enter the dashboard name",
          product: "Choose a product…"
        },
        report_package: {
          unsubscribe_reason: "Tell us your reasons for unsubscribing…",
          recipient_emails: "Type to search users…",
          name: "Enter the report package name",
          subject: "Enter the email subject",
          hour: "Select an hour of the day",
          password: "For password protected reports"
        },
        role: {
          care_form_groups: "None selected means there will be no restrictions",
          issue_panel_ids: "None selected means there will be no restrictions",
          rounding_flag_ids: "None selected means there will be no restrictions",
          survey_location_ids: "None selected means there will be no restrictions",
          workflow_template_groups: "None selected means there will be no restrictions"
        },
        rule: {
          unit_ids: "Select units…",
          hours: "Hours amount…",
          rounding_flag_id: "Select Rounding Flag…",
          completed_program_id: "Select Outreach Program…",
          successful_calls_count: "Calls amount…",
          enroll_in_program_id: "Select Outreach Program…",
          issue_count_mode: "Select count mode…",
          issue_count_threshold: "Provide count threshold…",
          issue_count_days: "Provide days amount…",
          issue_alert_id: "Select Issue Alert…"
        },
        user: {
          sso_emails: "Select emails for SSO…"
        },
        user_info: {
          alert_ids: "Select an alert…"
        },
        user_feedback: {
          message: "How can we help you?"
        },
        sso_connection: {
          care_provider_names: "Care Providers"
        }
      }
    }
  }
}

